/*jshint esversion: 6 */
(function () {
    var previousval = '';
    var segments = location.pathname.split("/");
    var getIncomeValues = function () {
        var obj = {
            incomes: {
                monthly: sumInputs('evaluation[income_approach][income_source][index][monthly_income]'), //Income Source
                annual: sumInputs('evaluation[income_approach][income_source][index][annual_income]'), //Income Source
                // rentSqFt: averageMaskedInputs('evaluation[income_approach][income_source][index][rent_sq_ft]', 'money'), //Income Source,
                // sqFeetAverage: sumAreaInputs('evaluation[income_approach][income_source][index][square_feet]', 'area') //Income Source
                rentSqFt: averageMaskedInputs('field-rent-sq-ft', true), //Income Source,
                sqFeetAverage: sumAreaInputs('prop_space', true) //Income Source
            },
            vacancy: sumInputs('evaluation[income_approach][vacancy]'), //Vacancy
            expenses: {
                annual: sumInputs('evaluation[income_approach][operating_expense][index][annual_amount]'), //Expense
                gross: sumInputs('evaluation[income_approach][operating_expense][index][percentage_of_gross]'), //Expense
                // amountPerSqFt: sumInputs('evaluation[income_approach][operating_expense][index][total_per_sq_ft]') //Expense
                amountPerSqFt: sumInputs('op_space_price', true) //Expense
            },
            rate: { //Capitalization Rate
                // monthly: sumInputs('evaluation[income_approach][net_income][monthly_capitalization_rate]'),
                // annual: sumInputs('evaluation[income_approach][net_income][annual_capitalization_rate]'),
                monthly: sumInputs('evaluation[income_approach][monthly_capitalization_rate]'),
                annual: sumInputs('evaluation[income_approach][annual_capitalization_rate]'),
                sqFeet: sumInputs('capitalization_rate', true)
            },
            net: 0, //Net Income Total [Calculated]
            vacant: 0,
            adjustedGross: 0,
            indicatedValueRange: {
                monthly: 0, //[Calculated]
                annual: 0, //[Calculated]
                sqFeet: 0 //[Calculated]
            },
            incrementalValue: {
                monthly: 0, //[Calculated]
                annual: 0, //[Calculated]
                sqFeet: 0 //[Calculated]
            },
            indicatedValuePSF: {
                monthly: 0, //[Calculated]
                annual: 0, //[Calculated]
                sqFeet: 0 //[Calculated]
            }
        };
        // $('input[name="evaluation[income_approach][net_income][high_capitalization_rate]"]').val($('.net_high_capitalization_rate').val()).keyup();
        $('input[name="evaluation[income_approach][high_capitalization_rate]"]').val($('.net_high_capitalization_rate').val()).keyup();
        var totalSf = get_number(obj.incomes.sqFeetAverage);
        var totalAnnual = get_number(obj.incomes.annual);

        obj.incomes.rentSqFt = totalAnnual / totalSf;

        return obj;
    };

    var setLabelValue = function (el, val) {
        if (val) {
            const building_size = parseFloat($("input[name='evaluation[building_size]']").val());
            let cal_val = 0;
            if (building_size > 0) {
                cal_val = val / building_size;
            }
            el.text(mask(cal_val));
        }
    };

    var setIncomeValues = function (obj) {
        if (obj !== undefined) {
            $('.income-source-entry').each(function () {
                var sf = parseFloat($(this).find('.income-source.space').val().replace(/[^\d.-]/g, ''));
                var annualIncomeVal = unmaskInput($(this).find('.field-annual-income'));

                if (annualIncomeVal === 0 || isNaN(annualIncomeVal)) {
                    var monthlyIncomeVal = unmaskInput($(this).find('.field-monthly-income'));
                    if (!isNaN(monthlyIncomeVal) && monthlyIncomeVal !== 0) {
                        annualIncomeVal = monthlyIncomeVal * 12;
                    }
                }

                if (!isNaN(sf) && sf !== 0) {
                    if (!isNaN(annualIncomeVal) && annualIncomeVal !== 0) {
                        // setInputValue($(this).find('.field-rent-sq-ft'), annualIncomeVal / sf);
                    }
                }
            });
            // var amountPerSqFtExpenses= sumInputs('evaluation[income_approach][operating_expense][index][total_per_sq_ft]');
            let amountPerSqFtExpenses = sumInputs('op_space_price', true);

            $('#oe-total-per-square-feet').text(mask(amountPerSqFtExpenses));
            if ($('#total-price-per-sf').length) {
                let total_price_per_sf = sumInputs('sf_field', true);
                $('#total-price-per-sf').text(mask(total_price_per_sf));
            }
            let field = $("[name='evaluation[income_approach][total_oe_per_square_feet]']");
            if ($('#comparison_basis_field').length) {
                if ($('#comparison_basis_field').val() != 'SF') {
                    let unit = $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase();
                    field = $("[name='evaluation[income_approach][total_oe_per_" + unit + "]']");
                }
            }
            field.val(amountPerSqFtExpenses);

            $('#income-approach-net-income-total').val(obj.net);
            $('#income-approach-vacant-total').val(obj.vacant);

            if (obj.vacant < 0) {
                $('#income-approach-vacant-label').text('(' + mask(-1 * obj.vacant) + ')');
            } else {
                $('#income-approach-vacant-label').text(mask(obj.vacant));
            }

            $('#income-approach-adjusted-gross-total').val(obj.adjustedGross);
            $('#income-approach-adjusted-gross-label').text(mask(obj.adjustedGross));

            $('#net-income-total-label').text(mask(obj.net));
            $('#indicated_value_monthly_label').text(mask(obj.indicatedValueRange.monthly));
            if ($('#indicated_psf_monthly_read_only').length) {
                setLabelValue($('#indicated_psf_monthly_read_only'), obj.indicatedValueRange.monthly);
            }
            $('#indicated_value_annual_label').text(mask(obj.indicatedValueRange.annual));
            if ($('#indicated_psf_annual_read_only').length) {
                setLabelValue($('#indicated_psf_annual_read_only'), obj.indicatedValueRange.annual);
            }
            $('#indicated_value_sq_feet_label').text(mask(obj.indicatedValueRange.sqFeet));
            if ($('#indicated_psf_sq_feet_read_only').length) {
                setLabelValue($('#indicated_psf_sq_feet_read_only'), obj.indicatedValueRange.sqFeet);
            }

            $('#indicated_value_monthly').val(obj.indicatedValueRange.monthly);
            $('#indicated_value_annual').val(obj.indicatedValueRange.annual);
            $('#indicated_value_sq_feet').val(obj.indicatedValueRange.sqFeet);

            $('#indicated_value_psf_monthly_label').text(mask(obj.indicatedValuePSF.monthly));
            $('#indicated_value_psf_monthly').val(obj.indicatedValuePSF.monthly);

            $('#indicated_value_psf_annual_label').text(mask(obj.indicatedValuePSF.annual));
            $('#indicated_value_psf_annual').val(obj.indicatedValuePSF.annual);

            $('#indicated_value_psf_sq_feet_label').text(mask(obj.indicatedValuePSF.sqFeet));
            $('#indicated_value_psf_sq_feet').val(obj.indicatedValuePSF.sqFeet);

            $('#incremental_value_monthly').val(obj.incrementalValue.monthly);
            $('#incremental_value_annual').val(obj.incrementalValue.annual);

            var oes = $('[name="evaluation[income_approach][operating_expense][index][annual_amount]"]');

            $.each(oes, function (i, oe) {
                var entry = $(oe).parents().closest('.operating-expense-entry');
                var gross = entry.find('[name="evaluation[income_approach][operating_expense][index][percentage_of_gross]"]');
                const sf_field = entry.find('.sf_field');
                // var sqft = entry.find('[name="evaluation[income_approach][operating_expense][index][total_per_sq_ft]"]');
                var sqft = entry.find('.op_space_price');
                var annual = $(oe).maskMoney('unmasked');

                if (annual.hasOwnProperty(0)) {
                    annual = annual[0];

                    if (obj.incomes.annual) {
                        // var gross_amount = annual / obj.incomes.annual * 100;
                        let adjusted_gross = $('#income-approach-adjusted-gross-total').val();
                        var gross_amount = annual / adjusted_gross * 100;
                        if (!isNaN(gross_amount)) {
                            setInputValue(gross, gross_amount);
                        }
                    }

                    if (obj.incomes.sqFeetAverage) {
                        var sq_ft = annual / obj.incomes.sqFeetAverage;
                        if (!isNaN(sq_ft)) {
                            setInputValue(sqft, sq_ft);
                        }
                        if (sf_field) {
                            const building_size = parseFloat($("input[name='evaluation[building_size]']").val());
                            let sf_field_val = annual / building_size;
                            setInputValue(sf_field, sf_field_val);
                        }
                    }
                }

            });
            var monthlyIncome = sumInputs('evaluation[income_approach][income_source][index][monthly_income]');
            var annualIncome = sumInputs('evaluation[income_approach][income_source][index][annual_income]');
            // var sqFeetAverageIncome = sumAreaInputs('evaluation[income_approach][income_source][index][square_feet]', 'area');
            var sqFeetAverageIncome = sumAreaInputs('prop_space', true);
            var rentSqFtIncome = mask(annualIncome / sqFeetAverageIncome);
            if (!sqFeetAverageIncome) {
                rentSqFtIncome = 0;
            }
            var annualExpenses = sumInputs('evaluation[income_approach][operating_expense][index][annual_amount]');
            var grossExpenses = sumInputs('evaluation[income_approach][operating_expense][index][percentage_of_gross]');
            // amountPerSqFtExpenses = sumInputs('evaluation[income_approach][operating_expense][index][total_per_sq_ft]');
            amountPerSqFtExpenses = sumInputs('op_space_price', true);

            $('#monthly-income-total').text(mask(monthlyIncome));
            // $("[name='evaluation[income_approach][total][monthly_income]']").val(monthlyIncome);
            $("[name='evaluation[income_approach][total_monthly_income]']").val(monthlyIncome);
            $('#annual-income-total').text(mask(annualIncome));
            $("[name='evaluation[income_approach][total_annual_income]']").val(annualIncome);
            $('#rent-sq-ft-total').text(rentSqFtIncome);
            let rent_field = $("[name='evaluation[income_approach][total_rent_sq_ft]']");
            let total_field = $("[name='evaluation[income_approach][total_sq_ft]']");
            if ($('#comparison_basis_field').length) {
                if ($('#comparison_basis_field').val() != 'SF') {
                    let unit = $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase();
                    rent_field = $("[name='evaluation[income_approach][total_rent_" + unit + "]']");
                    total_field = $("[name='evaluation[income_approach][total_" + unit + "]']");
                }
            }
            rent_field.val(unmask(rentSqFtIncome));
            $('#sq-ft-total').text(maskAreaAndRemoveDecimalPart(sqFeetAverageIncome));
            total_field.val(sqFeetAverageIncome);

            $('#oe-total-annual-amount').text(mask(annualExpenses));
            $('[name="evaluation[income_approach][total_oe_annual_amount]"]').val(annualExpenses);

            $('#oe-total-of-gross').text(mask(grossExpenses) + '%');
            $('[name="evaluation[income_approach][total_oe_gross]"]').val(grossExpenses);

            $('#oe-total-per-square-feet').text(mask(amountPerSqFtExpenses));
            if ($('#total-price-per-sf').length) {
                let total_price_per_sf = sumInputs('sf_field', true);
                $('#total-price-per-sf').text(mask(total_price_per_sf));
            }
            field.val(amountPerSqFtExpenses);

            focusInPostMasks();
        }
    };

    var setInputValue = function (el, val) {
        val = val && val !== Infinity ? val : 0;
        val = Math.round((val + Number.EPSILON) * 100) / 100;
        val = val.toFixed(2);
        el.val(val);
    };

    function calculateIncomeSource(incomeSourceRow, elementChanged) {
        var rentSqFt = $(incomeSourceRow).find('.field-rent-sq-ft');
        var area = $(incomeSourceRow).find('.income-source.space');
        var areaVal = parseFloat(area.val().replace(/[^\d.-]/g, ''));
        var monthlyIncome = $(incomeSourceRow).find('.field-monthly-income');
        var annualIncome = $(incomeSourceRow).find('.field-annual-income');

        var val = parseFloat($(elementChanged).val().replace(/[^0-9\.]/g, ''));

        // If monthly income, then set annual income and rent/sq.ft.
        if (elementChanged === monthlyIncome[0]) {
            setInputValue(annualIncome, val * 12);
            setInputValue(rentSqFt, (val * 12) / areaVal);
        }

        // If annual income, then set monthly and rent/sq.ft.
        if (elementChanged === annualIncome[0]) {
            setInputValue(monthlyIncome, val / 12);
            setInputValue(rentSqFt, val / areaVal);
        }

        // If rent/sq.ft., then set the monthly and annual
        if (elementChanged === rentSqFt[0]) {

            var areaValue = (isNaN(areaVal) || areaVal == 0) ? 1 : areaVal;

            setInputValue(annualIncome, val * areaValue);
            setInputValue(monthlyIncome, (val * areaValue) / 12);
        }
        // focusInPostMasks();

        ApproachCalculator.calculateIncomeApproach();
    }

    function initIncomeSourceEvents(e) {
        var area = $(e).find('.income-source.space');
        var annualIncome = $(e).find('.field-annual-income');
        var rentSqFt = $(e).find('.field-rent-sq-ft');
        var rentSqFtVal;

        // If sq.ft. change, re-calc the rent sq.ft.
        area.on('blur', _.debounce(function () {
            var sf = parseFloat($(this).val().replace(/\D/g, ''));
            var annualIncomeVal = unmaskInput(annualIncome);
            rentSqFtVal = annualIncomeVal / sf;
            setInputValue(rentSqFt, annualIncomeVal / sf);

            // if (location.pathname.indexOf('/income') == -1) {
            ApproachCalculator.calculateIncomeApproach();
            // }

        }, 500));

        $(e).find('.income-source.money').each(function () {
            if (location.pathname.indexOf('/income') !== -1) {
                var monthlyIncome = $(e).find('.field-monthly-income');
                var annualIncome = $(e).find('.field-annual-income');
                var rentSqFt = $(e).find('.field-rent-sq-ft');

                var oldVal = "";
                $(this).on('focus', function () {
                    oldVal = $(this).val();
                });
                $(this).on('keyup', _.debounce(function (event) {
                    currentval = $(this).val();
                    if (event.keyCode !== 9) {
                        $(this).removeClass('disabled-input');

                        if ($(this).hasClass('field-monthly-income')) {
                            annualIncome.addClass('disabled-input');
                            rentSqFt.addClass('disabled-input');
                        } else if ($(this).hasClass('field-annual-income')) {
                            monthlyIncome.addClass('disabled-input');
                            rentSqFt.addClass('disabled-input');
                        } else if ($(this).hasClass('field-rent-sq-ft')) {
                            monthlyIncome.addClass('disabled-input');
                            annualIncome.addClass('disabled-input');
                        }
                    } else {
                        return;
                    }

                    dataToSave = true;
                    calculateIncomeSource(e, this);
                }, 700));
            } else {
                $(this).on('blur', _.debounce(function () {
                    calculateIncomeSource(e, this);
                }, 1000));
            }
        });
    }

    /**
     * Calculate the empty input values
     */
    var calcIncomeValue = function () {
        $('.income-source-entry').each(function () {
            initIncomeSourceEvents(this);
        });
    };

    var getMultiValues = function (isAddDelete = 0) {
        var values = {
            comps: {},
            totalAverageAdjusted: 0, //PSF
            value: 0,
            incrementalValue: 0
        };

        var compsEl = $('div.col.comps.comp-entry');
        var comps = values.comps;
        let multiFields = [];
        $('.label-value').each(function () {
            multiFields.push($(this).attr('data-name'));
        });
        if (compsEl.length > 0) {
            var i = 1;
            compsEl.each(function (index, value) {
                var id = $(value).find("input[name='evaluation[multi_family_approach][comps][index][comp_id]']").val();
                let bed_bath_id = $(value).find("input[name='evaluation[multi_family_approach][comps][index][property_unit_id]']").val();
                let ids = id + bed_bath_id;
                if (ids) {
                    comps[ids] = {
                        totalAdjustment: 0,
                        adjustedMonthlyRent: 0,
                    };
                    var totalAdjustment = 0;
                    // Getting and summing up percentages
                    for (var key in multiFields) {
                        if (multiFields.hasOwnProperty(key)) {
                            var field;
                            if ($("#comp_adjustment_mode").val() == "Dollar") {
                                field = $(value).find("input[name='evaluation[multi_family_approach][comps][index][" + multiFields[key] + "]']");
                            } else {
                                field = $(value).find("select[name='evaluation[multi_family_approach][comps][index][" + multiFields[key] + "]']");
                                if (field.val() == 'Type My Own')
                                    field = $(value).find("input[name='evaluation[multi_family_approach][comps][index][" + multiFields[key] + "_custom]']");
                            }

                            let field_val = 0;
                            if (field.val())
                                field_val = field.val().replace(/[^\d.-]/g, '');

                            if (field && isNotNull(field_val)) {
                                comps[ids][multiFields[key]] = parseFloat(field_val);
                                totalAdjustment += comps[ids][multiFields[key]];
                            } else {
                                comps[ids][multiFields[key]] = 0;
                            }
                        }
                    }
                    //Total adjustment
                    if (isNotNull(totalAdjustment)) {
                        comps[ids].totalAdjustment = totalAdjustment;
                    }

                    var avg_monthly_rent = $(value).find("input[name='single_comp[avg_monthly_rent]']").val();
                    comps[ids].avg_monthly_rent = parseFloat(avg_monthly_rent);

                    if ($("#comp_adjustment_mode").val() == "Dollar") {
                        comps[ids].adjustedMonthlyRent = parseFloat(comps[ids].avg_monthly_rent + comps[ids].totalAdjustment);
                    } else {
                        comps[ids].adjustedMonthlyRent = parseFloat(comps[ids].avg_monthly_rent + (comps[ids].avg_monthly_rent * comps[ids].totalAdjustment / 100));
                    }

                    values.comps[ids] = comps[ids];
                }
                i++;
            });
        }
        return values;
    };

    var setMultiValues = function (obj) {
        if (obj !== undefined) {

            let comparison_avg_value = [];

            for (var id in obj.comps) {
                if (obj.comps.hasOwnProperty(id)) {
                    var comp = obj.comps[id];
                    var el = $('.comp-entry[data-id=' + id + ']');
                    if ($("#comp_adjustment_mode").val() == "Dollar") {
                        el.find('span.total-adjustment').text((comp.totalAdjustment < 0 ? '-$' : '$') + mask(Math.abs(comp.totalAdjustment))); //View
                    } else {
                        el.find('span.total-adjustment').text(mask(comp.totalAdjustment)); //View
                    }
                    el.find("input[name='evaluation[multi_family_approach][comps][index][total_adjustment]']").val(comp.totalAdjustment);

                    el.find('span.adjusted_montly_val').text(mask(comp.adjustedMonthlyRent)); //View
                    el.find("input[name='evaluation[multi_family_approach][comps][index][adjusted_montly_val]']").val(comp.adjustedMonthlyRent);
                }
                $('span.adjusted_montly_val').each(function () {
                    comparison_avg_value.push(el.find("input[name='evaluation[multi_family_approach][comps][index][adjusted_montly_val]']").val());
                });
            }
            comparison_avg_value.sort(function (a, b) { return a - b });
            let high_val = comparison_avg_value.length - 1;
            $('.evaluation-approach-property').find('.multi-family-comparison-value').text('$' + ((comparison_avg_value[0] !== undefined) ? mask(comparison_avg_value[0]) : parseFloat(0).toFixed(2)) + ' - ' + '$' + ((comparison_avg_value[high_val] !== undefined) ? mask(comparison_avg_value[high_val]) : parseFloat(0).toFixed(2)));
            $('.evaluation-approach-property').find("input[name='evaluation[multi_family_approach][low_rental_rate]']").attr('value', parseFloat(comparison_avg_value[0]).toFixed(2));
            $('.evaluation-approach-property').find("input[name='evaluation[multi_family_approach][high_rental_rate]']").attr('value', parseFloat(comparison_avg_value[high_val]).toFixed(2));

        }
    };

    var getSalesValues = function (isAddDelete = 0) {
        var values = {
            comps: {},
            totalWeights: 0,
            totalAverageAdjusted: 0, //PSF
            value: 0,
            incrementalValue: 0
        };

        var compsEl = $('div.col.comps.comp-entry');
        var comps = values.comps;
        let salesFields = [];
        $('.label-value').each(function () {
            salesFields.push($(this).attr('data-name'));
        });
        if (compsEl.length > 0) {
            var i = 1;
            compsEl.each(function (index, value) {
                var id = $(value).find("input[name='evaluation[sales_approach][comps][index][comp_id]']").val();

                if (id) {
                    comps[id] = {
                        totalAdjustment: 0,
                        weight: 0,
                        salePrice: 0,
                        buildingSize: 0,
                        psf: 0,
                        adjustedPricePSF: 0,
                        blendedAdjustedPricePSF: 0
                    };

                    var totalAdjustment = 0;

                    // Getting and summing up percentages
                    for (var key in salesFields) {
                        if (salesFields.hasOwnProperty(key)) {
                            var field;
                            if ($("#comp_adjustment_mode").val() == "Dollar") {
                                field = $(value).find("input[name='evaluation[sales_approach][comps][index][" + salesFields[key] + "]']");
                            } else {
                                field = $(value).find("select[name='evaluation[sales_approach][comps][index][" + salesFields[key] + "]']");
                                if (field.val() == 'Type My Own')
                                    field = $(value).find("input[name='evaluation[sales_approach][comps][index][" + salesFields[key] + "_custom]']");
                            }

                            // var field_val = field.val().replace(/[^\d.-]/g, '');
                            let field_val = 0;
                            if (field.val())
                                field_val = field.val().replace(/[^\d.-]/g, '');
                            // var field_val = field.val();
                            if (field && isNotNull(field_val)) {
                                comps[id][salesFields[key]] = parseFloat(field_val);
                                totalAdjustment += comps[id][salesFields[key]];
                            } else {
                                comps[id][salesFields[key]] = 0;
                            }
                        }
                    }
                    // $('.currency').maskMoney('mask');

                    //Total adjustment
                    if (isNotNull(totalAdjustment)) {
                        comps[id].totalAdjustment = totalAdjustment;
                    }

                    //Weight
                    var weightFieldEl = $(value).find("input[name='evaluation[sales_approach][comps][index][weight]']");
                    if (weightFieldEl.length) {
                        if ($(weightFieldEl).val() && $(weightFieldEl).val().length) {
                            var weightField = $(weightFieldEl).val().replace(/,/g, '.');
                            // var weightField = $(weightFieldEl).masked($(weightFieldEl).val()).replace(/,/g, '.');
                            if (weightField.length) {
                                if (weightField == "%") {
                                    weightField = 0;
                                }
                                comps[id].weight = parseFloat(weightField);
                                // $(weightFieldEl).val(comps[id].weight.toFixed(2) + "%");
                                $(weightFieldEl).val(comps[id].weight + "%");
                            }
                        }
                    }

                    //Total weights
                    values.totalWeights += comps[id].weight;

                    var salePrice = $(value).find("input[name='single_comp[sale_price]']").val();
                    var buildingSize = $(value).find("input[name='single_comp[building_size]']").val();
                    var price_psf = $(value).find("input[name='single_comp[price_psf]']").val();
                    var price_acre = $(value).find("input[name='single_comp[price_acre]']").val();

                    // if (isNotNull(salePrice) && isNotNull(buildingSize)) {
                    if (isNotNull(salePrice)) {
                        comps[id].salePrice = parseFloat(salePrice);
                        comps[id].buildingSize = parseFloat(buildingSize);
                        // comps[id].psf = comps[id].salePrice / comps[id].buildingSize;
                        comps[id].psf = parseFloat(price_psf);
                        comps[id].pacre = parseFloat(price_acre);
                        if ($("#comp_adjustment_mode").val() == "Dollar") {
                            if ($('#selected_comp_type').val() === 'land_only' && $('#selected_analysis_type').val() === '$/Acre') {
                                comps[id].adjustedPricePSF = parseFloat(comps[id].pacre + comps[id].totalAdjustment);
                            } else {
                                comps[id].adjustedPricePSF = parseFloat(comps[id].psf + comps[id].totalAdjustment);
                            }
                        } else {
                            if ($('#selected_comp_type').val() === 'land_only' && $('#selected_analysis_type').val() === '$/Acre') {
                                comps[id].adjustedPricePSF = parseFloat(comps[id].pacre + (comps[id].pacre * comps[id].totalAdjustment / 100));
                            } else {
                                comps[id].adjustedPricePSF = parseFloat(comps[id].psf + (comps[id].psf * comps[id].totalAdjustment / 100));
                            }
                        }
                    }

                    if (isNotNull(comps[id].adjustedPricePSF) && isNotNull(comps[id].weight)) {
                        var weight;
                        if (isAddDelete == 1) {
                            if (compsEl.length == 3 && i == 3) {
                                weight = 33.34;
                            } else if (compsEl.length == 3 && i != 3) {
                                weight = 33.33;
                            } else {
                                var compCount = compsEl.length;
                                weight = 100 / compCount;
                            }
                        } else {
                            weight = comps[id].weight;
                        }
                        comps[id].averageAdjustedPSF = parseFloat(comps[id].adjustedPricePSF * (weight / 100));
                        comps[id].averageAdjustedPSF = parseFloat(comps[id].averageAdjustedPSF);

                        if (price_psf) {
                            comps[id].blendedAdjustedPricePSF = parseFloat((weight / 100) * price_psf);
                            comps[id].blendedAdjustedPricePSF = parseFloat(comps[id].blendedAdjustedPricePSF);
                        }

                        values.totalAverageAdjusted += comps[id].averageAdjustedPSF;
                    }
                    values.comps[id] = comps[id];
                }
                i++;
            });
            // var compCount = Object.keys(comps).length;
            var compCount = compsEl.length;
            var w = 100 / compCount;
            var updated = false;

            var allWeight = [];

            // var needToSplit = false;
            var needToSplit = true;

            Object.keys(comps).forEach(function (item) {
                if (comps[item].weight != w) {
                    updated = true;
                }
                allWeight.push(comps[item].weight);

                if (comps[item].index + 1 == compCount) {
                    if (comps[item].weight == 0) {
                        needToSplit = true;
                    }
                }
            });

            if (needToSplit) {
                const index = allWeight.indexOf(0);
                if (index > -1) {
                    allWeight.splice(index, 1);
                }
            }

            if (allWeight.length == 0 && values.totalWeights == 0) {
                updated = false;
                values.totalWeights = 100;
            }

            if (allWeight.every((val, i, arr) => val === arr[0]) && values.totalWeights == 100) {
                updated = false;
                values.totalWeights = 100;
            }

            if (isAddDelete == 1) {
                updated = false;
                values.totalWeights = 100;
            }

            if (allWeight.length == 3) {

                let count = 0;
                allWeight.forEach(e => {
                    if (e == 33.33 || e == 33.34)
                        count++;
                });

                if (count == 3) {
                    updated = false;
                    values.totalWeights = 100;
                }
            }

            if (updated == false) {
                var weightFieldEl = $('div.col.comps.comp-entry').find("input[name='evaluation[sales_approach][comps][index][weight]']");

                // $(weightFieldEl).val(w.toFixed(2) + "%");
                $(weightFieldEl).val(w + "%");
                if (w.toFixed(2) == 33.33) {
                    $(weightFieldEl).val(w.toFixed(2) + "%");
                    $("input[name='evaluation[sales_approach][comps][index][weight]']:nth(2)").val("33.34%");
                }

            }

            values.totalAverageAdjusted = parseFloat(values.totalAverageAdjusted);
        }

        // Check whether the weight is 100%.  If it isn't, disable the next button
        var button = $('button.evaluations-next');
        var currentWeight = $('.current_weight').parent('.field');

        if ((values.totalWeights !== 100)) {
            // button.attr('disabled', 'disabled');
            $('.tooltip-wrapper').tooltip({
                delay: 50,
                position: 'bottom',
                tooltip: 'Please ensure that weighting equals 100%'
            });
            currentWeight.addClass('error');
        } else {
            button.attr('disabled', false);
            // $('.tooltip-wrapper').tooltip('remove');
            currentWeight.removeClass('error');
        }
        return values;
    };

    var setSalesValues = function (obj) {
        if (obj !== undefined) {

            var current = $('.comp-current');
            current.find('span.current_weight').text(mask(obj.totalWeights)); //View
            current.find("input[name='evaluation[sales_approach][weight]']").val(obj.totalWeights);
            if ($('#selected_comp_type').val() === 'land_only' && $('#selected_analysis_type').val() === '$/Acre')
                current.find('span.current_averaged_adjusted_psf').text(mask(obj.totalAverageAdjusted) + " /AC"); //View
            else
                current.find('span.current_averaged_adjusted_psf').text(mask(obj.totalAverageAdjusted) + "/" + $('#comparison_basis_field').val()); //View

            if ($('#comparison_basis_field').length && $('#comparison_basis_field').val() != 'SF') {
                const building_size = parseFloat($("input[name='evaluation[building_size]']").val());
                let sf_val = obj.value / building_size;
                if (sf_val === Infinity) {
                    sf_val = 'N/A';
                } else {
                    sf_val = "$" + mask(sf_val) + "/SF";
                }
                current.find('span.current_averaged_adjusted_psqft').text(sf_val);
            }
            current.find("input[name='evaluation[sales_approach][averaged_adjusted_psf]']").val(obj.totalAverageAdjusted);
            if ($('#comparison_basis_field').val() == 'SF' && $("#selected_comp_type").val() != "land_only") {
                let finalValue = 0;
                $('.data').each(function () {
                    sqftValue = $(this).find('.sqft_value').val();
                    weightValue = $(this).find('.weightsf_value').val();
                    finalValue += getTotalSalesValue((obj.totalAverageAdjusted).toFixed(2), sqftValue, weightValue);
                });
                current.find('span.current_sales_approach_value').text((finalValue) ? '$' + mask(finalValue) : 'N/A');
                current.find("input[name='evaluation[sales_approach][sales_approach_value]']").val(finalValue);
            } else {
                current.find('span.current_sales_approach_value').text((obj.value) ? '$' + mask(obj.value) : 'N/A');
                current.find("input[name='evaluation[sales_approach][sales_approach_value]']").val(obj.value);
            }
            current.find("input[name='evaluation[sales_approach][total_comp_adj]']").val(obj.compAdj);
            current.find("input[name='evaluation[sales_approach][incremental_value]']").val(obj.incrementalValue);

            for (var id in obj.comps) {
                if (obj.comps.hasOwnProperty(id)) {
                    var comp = obj.comps[id];
                    var el = $('.comp-entry[data-id=' + id + ']');
                    if ($("#comp_adjustment_mode").val() == "Dollar") {
                        el.find('span.total-adjustment').text((comp.totalAdjustment < 0 ? '-$' : '$') + mask(Math.abs(comp.totalAdjustment))); //View
                    } else {
                        el.find('span.total-adjustment').text(mask(comp.totalAdjustment)); //View
                    }
                    el.find("input[name='evaluation[sales_approach][comps][index][total_adjustment]']").val(comp.totalAdjustment);

                    el.find('span.blended_adjusted_psf').text(mask(comp.blendedAdjustedPricePSF)); //View
                    el.find("input[name='evaluation[sales_approach][comps][index][blended_adjusted_psf]']").val(comp.blendedAdjustedPricePSF);

                    el.find('span.adjusted_psf').text(mask(comp.adjustedPricePSF)); //View
                    el.find("input[name='evaluation[sales_approach][comps][index][adjusted_psf]']").val(comp.adjustedPricePSF);

                    el.find('span.averaged_adjusted_psf').text(mask(comp.averageAdjustedPSF)); //View
                    el.find("input[name='evaluation[sales_approach][comps][index][averaged_adjusted_psf]']").val(comp.averageAdjustedPSF);
                }
            }
        }
    };

    var getTotalSalesValue = function (adjust, sf, weight = 100) {
        let value = (sf * weight) / 100;
        let total = adjust * value;
        return total;
    }
    var getCostValues = function (isAddDelete = 0) {

        var values = {
            comps: {},
            improvements: [],
            improvementsTotalSfArea: 0,
            improvementsTotalSubjectLf: 0,
            improvementsTotalCompBase: 0,
            improvementsTotalCompLf: 0,
            improvementsTotalPerimeterAdj: 0,
            improvementsTotalLocationAdj: 0,
            improvementsTotalAdjustedPPSF: 0,
            improvementsTotalDepreciation: 0,
            improvementsTotalAdjustedCost: 0,
            totalAdjustedPrice: 0,
            landValue: 0,
            overallReplacementCost: 0,
            totalDepreciation: 0,
            totalDepreciationPercentage: 0,
            totalDepreciatedCost: 0,
            indicatedValuePSF: 0,
            totalCostValuation: 0,
            totalIncrementalValue: 0,
            totalWeights: 0,
            totalNewAdjustedCost: 0,
            totalstructureCost: 0
        };

        if (isInArray('cost', segments)) {
            values = getLandValue(values, isAddDelete);
        } else if (isInArray('cost-improvement', segments)) {
            values = getTotalCostValuation(values);
        }

        return values;
    };

    var getResCostValues = function (isAddDelete = 0) {

        var values = {
            comps: {},
            improvements: [],
            improvementsTotalSfArea: 0,
            improvementsTotalSubjectLf: 0,
            improvementsTotalCompBase: 0,
            improvementsTotalCompLf: 0,
            improvementsTotalPerimeterAdj: 0,
            improvementsTotalLocationAdj: 0,
            improvementsTotalAdjustedPPSF: 0,
            improvementsTotalDepreciation: 0,
            improvementsTotalAdjustedCost: 0,
            totalAdjustedPrice: 0,
            landValue: 0,
            overallReplacementCost: 0,
            totalDepreciation: 0,
            totalDepreciationPercentage: 0,
            totalDepreciatedCost: 0,
            indicatedValuePSF: 0,
            totalCostValuation: 0,
            totalIncrementalValue: 0,
            totalWeights: 0,
            totalNewAdjustedCost: 0,
            totalstructureCost: 0
        };

        if (isInArray('cost', segments)) {
            values = getResLandValue(values, isAddDelete);
        } else if (isInArray('cost-improvement', segments)) {
            values = getTotalResCostValuation(values);
        }

        return values;
    }

    function getTotalResCostValuation(values) {
        var type = $('select[name="evaluation[cost_approach_improvement][type]"]').val();

        var costImprovementFields = ['sf_area', 'subject_lf', 'adjusted_psf', 'comp_base', 'comp_lf', 'perimeter_adj', 'location_adj', 'depreciation', 'custom_sf_total_area', 'sf_area'];

        if (type === 'advanced') {
            costImprovementFields = ['sf_area', 'subject_lf', 'comp_base', 'comp_lf', 'perimeter_adj', 'location_adj', 'depreciation'];
        }

        var improvementsCount = 0;
        var improvementsEntries = $('div.cost-approach-improvement-entry');
        var costImprovements = {};

        improvementsEntries.each(function (index, value) {
            costImprovements[improvementsCount] = {
                adjustedPSF: 0,
                structureCost: 0,
                depreciationAmount: 0,
                adjustedCost: 0
            };

            //Extract amounts
            for (var key in costImprovementFields) {
                if (costImprovementFields.hasOwnProperty(key)) {
                    var field = $(value).find("input[name='evaluation[cost_approach_improvement][improvements][index][" + costImprovementFields[key] + "]']");
                    var isCountable = true;
                    if (!field.hasClass('disabled-improvement')) {
                        isCountable = false;
                    }

                    if (field.attr('name') == 'evaluation[cost_approach_improvement][improvements][index][sf_area]' && field.hasClass('count-total-sf-area')) {
                        var sffieldValue = getValue(field[0]);
                        if (isNotNull(sffieldValue)) {
                            costImprovements[improvementsCount].custom_sf_total_area = sffieldValue;
                        } else {
                            costImprovements[improvementsCount].custom_sf_total_area = 0;
                        }
                    }

                    if (field && field.val()) {
                        var fieldValue = getValue(field[0]);
                        if (!isCountable) {
                            fieldValue = 0;
                        }

                        if (typeof (fieldValue) === 'string') {
                            fieldValue = parseFloat(fieldValue);
                        }

                        if (isNotNull(fieldValue)) {
                            costImprovements[improvementsCount][costImprovementFields[key]] = fieldValue;
                        } else {
                            costImprovements[improvementsCount][costImprovementFields[key]] = 0;
                        }
                    } else {
                        costImprovements[improvementsCount][costImprovementFields[key]] = 0;
                    }
                }

                costImprovements[improvementsCount].object = $(value);
            }

            improvementsCount++;
        });

        values.improvements = costImprovements;

        for (var improvementIndex in costImprovements) {
            var improvement = costImprovements[improvementIndex];

            //Calculating Adjusted PSF for Improvement
            if (type === 'advanced') {
                improvement.adjustedPSF = (improvement.comp_base - (improvement.comp_lf - improvement.subject_lf) * (improvement.perimeter_adj / 100)) * (0.89 - (improvement.location_adj / 100));
            } else {
                improvement.adjustedPSF = improvement.adjusted_psf;
            }

            //Calculating structure cost for Improvement
            improvement.structureCost = improvement.adjustedPSF * improvement.sf_area;

            //Calculating Depreciation Amount for Improvement
            improvement.depreciationAmount = improvement.structureCost * (improvement.depreciation / 100);

            //Calculating Structure Cost for Improvement
            improvement.adjustedCost = improvement.structureCost - improvement.depreciationAmount;

            //Calculating Total Overall Replacement Cost
            values.overallReplacementCost = values.overallReplacementCost + improvement.structureCost;

            //Calculating Total Depreciation
            values.totalDepreciation = values.totalDepreciation + improvement.depreciationAmount;
            values.totalstructureCost = values.totalstructureCost + improvement.structureCost;
            values.improvementsTotalSfArea += parseInt(improvement.custom_sf_total_area);
            values.improvementsTotalSubjectLf += improvement.subject_lf;
            values.improvementsTotalCompBase += improvement.comp_base;
            values.improvementsTotalCompLf += improvement.comp_lf;
            values.improvementsTotalPerimeterAdj += improvement.perimeter_adj;
            values.improvementsTotalLocationAdj += improvement.location_adj;
            values.improvementsTotalAdjustedPPSF += improvement.adjustedPSF;
            values.improvementsTotalAdjustedCost += improvement.adjustedCost;
            values.totalNewAdjustedCost += improvement.structureCost;
        }

        var buildingSize = parseFloat($("input[name='building_size']").val());
        if (!isNaN(parseFloat(values.overallReplacementCost)) && !isNaN(parseFloat(values.totalDepreciation))) {
            var response = JSON.parse($('#cost-data').html());

            if (!isNaN(parseFloat(response.land_value)) && !isNaN(parseFloat(response.averaged_adjusted_psf))) {
                values.landValue = parseFloat(response.land_value);
                values.totalAdjustedPrice = parseFloat(response.averaged_adjusted_psf);
            }
            var costWeight = $('#cost-approach-percentage').attr('data-value');

            if (!isNotNull(costWeight)) {
                costWeight = 0;
            }

            //Total Depreciation Cost
            values.totalDepreciatedCost = values.overallReplacementCost - values.totalDepreciation;
            values.totalDepreciationPercentage = values.totalDepreciation / (values.overallReplacementCost !== 0 ? values.overallReplacementCost : 1);
            values.totalCostValuation = values.totalDepreciatedCost + values.landValue;
            values.totalIncrementalValue = values.totalCostValuation * (costWeight / 100);
            values.indicatedValuePSF = values.totalCostValuation / (values.improvementsTotalSfArea !== 0 ? values.improvementsTotalSfArea : 1);
            if ($('#comparison_basis_field').length) {
                let field_val = $('#total_' + $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase()).val();
                if (($('#comparison_basis_field').val() == 'Unit') && field_val > 0) {
                    values.indicatedValuePUnit = values.totalCostValuation / field_val;
                } else if (($('#comparison_basis_field').val() == 'Bed') && field_val > 0) {
                    values.indicatedValuePBed = values.totalCostValuation / field_val;
                }
            }
            values.improvementsTotalDepreciation = (values.totalDepreciation / values.totalNewAdjustedCost) * 100;
            values.improvementsTotalAdjustedPPSF = values.improvementsTotalAdjustedCost / (values.improvementsTotalSfArea !== 0 ? values.improvementsTotalSfArea : 1);
            // }
        }

        return values;
    }

    /**
     * Calculate the Land Value for the cost approach.
     * @param values
     * @returns {*}
     */
    function getLandValue(values, isAddDelete = 0) {
        let costFields = [];
        $('.label-value').each(function () {
            costFields.push($(this).attr('data-name'));
        });
        var compsEl = $('div.col.comps.comp-entry');

        var improvementsArray = [];
        var comps = values.comps;

        var totalPsf = 0;

        if (compsEl.length > 0) {
            compsEl.each(function (index, value) {
                // var id = $(value).find("input[name='evaluation[cost_approach][comps][index][id]']").val();
                var id = $(value).find("input[name='evaluation[cost_approach][comps][index][comp_id]']").val();

                if (id) {
                    comps[id] = {
                        totalAdjustment: 0,
                        salePrice: 0,
                        buildingSize: 0,
                        psf: 0,
                        adjustedPricePSF: 0,
                        weight: 0,
                        landDimension: 0,
                        index: 0
                    };

                    for (var key in costFields) {
                        if (costFields.hasOwnProperty(key)) {
                            var field;
                            if ($("#comp_adjustment_mode").val() == "Dollar") {
                                field = $(value).find("input[name='evaluation[cost_approach][comps][index][" + costFields[key] + "]']");
                            } else {
                                field = $(value).find("select[name='evaluation[cost_approach][comps][index][" + costFields[key] + "]']");
                                if (field.val() == 'Type My Own')
                                    field = $(value).find("input[name='evaluation[cost_approach][comps][index][" + costFields[key] + "_custom]']");
                            }
                            // var field_val = field.val().replace(/[^\d.-]/g, '');
                            let field_val = 0;
                            if (field.val())
                                field_val = field.val().replace(/[^\d.-]/g, '');
                            if (field && isNotNull(field_val)) {
                                comps[id][costFields[key]] = parseFloat(field_val);
                                comps[id].totalAdjustment += comps[id][costFields[key]];
                            } else {
                                comps[id][costFields[key]] = 0;
                            }
                        }
                    }
                    $('.currency').maskMoney('mask');

                    var salePrice = $(value).find("input[name='single_comp[sale_price]']").val();
                    var buildingSize = $(value).find("input[name='single_comp[building_size]']").val();
                    var landSize = $(value).find("input[name='single_comp[land_size]']").val();
                    var landDimension = $(value).find("input[name='single_comp[land_dimension]']").val();
                    var indi_weight = $(value).find("input[name='evaluation[cost_approach][comps][index][weight]']").val();
                    if (indi_weight === "") {
                        indi_weight = 0;
                    }

                    if (isNotNull(salePrice) && isNotNull(buildingSize)) {
                        comps[id].salePrice = parseFloat(salePrice);
                        comps[id].buildingSize = parseFloat(buildingSize);
                        comps[id].landSize = parseFloat(landSize);
                        comps[id].indi_weight = parseFloat(indi_weight);

                        if (landDimension === 'ACRE') {
                            comps[id].landSize = comps[id].landSize * 43560;
                        } else {
                            comps[id].landSize = comps[id].landSize;
                        }
                        if (isInArray('cost', segments) && $("input[name='evaluation[landDimension]']").val() === 'ACRE') {
                            if (landDimension === 'ACRE') {
                                comps[id].landSize = parseFloat(landSize);
                            } else {
                                comps[id].landSize = (parseFloat(landSize) / 43560).toFixed(3);
                            }
                        }
                        let psf = (comps[id].landSize > 0) ? (comps[id].salePrice / comps[id].landSize) : 0;
                        if ($("#comp_adjustment_mode").val() == "Dollar") {
                            comps[id].adjustedPricePSF = psf + parseFloat(comps[id].totalAdjustment);
                        } else {
                            comps[id].adjustedPricePSF = psf * (1 + (parseFloat(comps[id].totalAdjustment) / 100));
                        }
                        comps[id].psf = comps[id].adjustedPricePSF;
                        // if(!comps[id].landSize){
                        //     comps[id].psf = 0;
                        //     comps[id].adjustedPricePSF = 0;
                        // }
                        values.totalAdjustedPrice += (comps[id].psf.toFixed(2)) * (comps[id].indi_weight / 100);

                        totalPsf += comps[id].adjustedPricePSF;
                    }
                    //Weight
                    var weightFieldEl = $(value).find("input[name='evaluation[cost_approach][comps][index][weight]']");
                    if (weightFieldEl.length) {
                        if ($(weightFieldEl).val() && $(weightFieldEl).val().length) {
                            var weightField = $(weightFieldEl).val().replace(/,/g, '.');
                            if (weightField.length) {
                                comps[id].weight = parseFloat(weightField);
                                // $(weightFieldEl).val(comps[id].weight.toFixed(2) + "%");
                                $(weightFieldEl).val(comps[id].weight + "%");
                            }
                        }
                    }
                    //Total weights
                    values.totalWeights += comps[id].weight;
                }
                comps[id].index = index;
            });
            if (isAddDelete === 1) {
                values.totalAdjustedPrice = totalPsf / compsEl.length;
            }
            var current = $('.comp-current');
            // if(isInArray('cost', segments) && $("input[name='evaluation[landDimension]']").val() === 'ACRE' && $("#comp_adjustment_mode").val() == 'Percent'){
            //     current.find('span.current_averaged_adjusted_psf').text(mask(Utils.roundup(values.totalAdjustedPrice*43560)));
            // }else{
            current.find('span.current_averaged_adjusted_psf').text(mask(Utils.roundup(values.totalAdjustedPrice)));
            // }

            current.find("input[name='evaluation[cost_approach][averaged_adjusted_psf]']").val(values.totalAdjustedPrice);

            // var compCount = Object.keys(comps).length;
            var compCount = compsEl.length;
            var w = 100 / compCount;
            var updated = false;

            var allWeight = [];

            var needToSplit = false;

            Object.keys(comps).forEach(function (item) {
                if (comps[item].weight != w) {
                    updated = true;
                }
                allWeight.push(comps[item].weight);

                if (comps[item].index + 1 == compCount) {
                    if (comps[item].weight == 0) {
                        needToSplit = true;
                    }
                }
            });

            if (needToSplit) {
                const index = allWeight.indexOf(0);
                if (index > -1) {
                    allWeight.splice(index, 1);
                }
            }

            if (allWeight.length == 0 && values.totalWeights == 0) {
                updated = false;
                values.totalWeights = 100;
            }

            if (allWeight.every((val, i, arr) => val === arr[0]) && values.totalWeights == 100) {
                updated = false;
                values.totalWeights = 100;
            }

            if (isAddDelete == 1) {
                updated = false;
                values.totalWeights = 100;
            }

            if (allWeight.length == 3) {

                let count = 0;
                allWeight.forEach(e => {
                    if (e == 33.33 || e == 33.34)
                        count++;
                });

                if (count == 3) {
                    updated = false;
                    values.totalWeights = 100;
                }
            }

            if (updated == false) {
                var weightFieldEl = $('div.col.comps.comp-entry').find("input[name='evaluation[cost_approach][comps][index][weight]']");

                // $(weightFieldEl).val(w.toFixed(2) + "%");
                $(weightFieldEl).val(w + "%");
                if (w.toFixed(2) == 33.33) {
                    $(weightFieldEl).val(w.toFixed(2) + "%");
                    $("input[name='evaluation[cost_approach][comps][index][weight]']:nth(2)").val("33.34%");
                }
            }

            var button = $('button.evaluations-next');
            var currentWeight = $('.current_weight').parent('.field');

            $("input[name='evaluation[cost_approach][weight]']").val(values.totalWeights);
            $(".current_weight").html(values.totalWeights.toFixed(2));

            if ((values.totalWeights !== 100)) {
                button.attr('disabled', 'disabled');

                currentWeight.addClass('error');
            } else {
                button.attr('disabled', false);
                // button.tooltip('remove');
                currentWeight.removeClass('error');
            }

        }

        //Land size
        var landSize = 0.0;
        $('.comp-current').each(function (index, obj) {
            var sizeInput = $(obj).find('input[name="current[land_size]"]');

            if (sizeInput && sizeInput.val() > 0) {
                var val = parseFloat(sizeInput.val());
                var dimensionInput = $(obj).find('input[name="current[land_dimension]"]');

                if (dimensionInput && dimensionInput.val().length > 0) {
                    if (dimensionInput.val() === 'SF') {
                        if (!isNaN(val)) {
                            landSize += val;
                        }
                    } else if (dimensionInput.val() === 'ACRE') {
                        if (!isNaN(val)) {
                            // if(isInArray('cost', segments) && $("#comp_adjustment_mode").val() == 'Dollar'){
                            landSize += val; //convert to ACRE
                            // }else{
                            //     landSize += val * 43560; //convert to SF
                            // }
                        }
                    }
                } else {
                    if (!isNaN(val)) {
                        landSize += val;
                    }
                }
            }
        });

        values.landSize = landSize;

        //Land Value
        if (!isNaN(parseFloat(values.totalAdjustedPrice))) {
            values.landValue = parseFloat(landSize) * values.totalAdjustedPrice.toFixed(2);
        }

        var buildingSize = parseFloat($("input[name='current[building_size]']").val());

        if (!isNaN(parseFloat(values.totalAdjustedPrice)) && !isNaN(parseFloat(values.landValue))) {
            if ($('#cost-data').html().length > 0) {
                var jsonresponse = $('#cost-data').html();
                var response = JSON.parse(jsonresponse);
                for (var i in response.improvements) {
                    if (response.improvements.hasOwnProperty(i)) {
                        var improvement = response.improvements[i];

                        improvement.adjustedPSF = 0;
                        improvement.structureCost = 0;
                        improvement.depreciationAmount = 0;
                        improvement.adjustedCost = 0;
                        improvement.comp_base = get_number(improvement.comp_base);
                        improvement.comp_lf = get_number(improvement.comp_lf);
                        improvement.subject_lf = get_number(improvement.subject_lf);
                        improvement.perimeter_adj = get_number(improvement.perimeter_adj);
                        improvement.location_adj = get_number(improvement.location_adj);
                        improvement.depreciation = get_number(improvement.depreciation);
                        improvement.sf_area = get_number(improvement.sf_area);

                        //Adjusted PSF
                        if (response.type === 'advanced') {
                            var adjustedPPSF = (improvement.comp_base - (improvement.comp_lf - improvement.subject_lf) * (improvement.perimeter_adj / 100)) * (0.89 - (improvement.location_adj / 100));
                            improvement.adjustedPSF = get_number(adjustedPPSF);
                        } else {
                            improvement.adjustedPSF = get_number(improvement.adjusted_psf);
                        }

                        //Structure Cost
                        improvement.structureCost = improvement.adjustedPSF * improvement.sf_area;

                        //Depreciation Amount
                        improvement.depreciationAmount = improvement.structureCost * (improvement.depreciation / 100);

                        //Adjusted Cost
                        improvement.adjustedCost = improvement.structureCost - improvement.depreciationAmount;

                        //Overall Replacement Cost
                        values.overallReplacementCost += improvement.structureCost;

                        //Total Depreciation
                        values.totalDepreciation += improvement.depreciationAmount;

                        values.improvementsTotalSfArea += improvement.sf_area;
                        values.improvementsTotalSubjectLf += improvement.subject_lf;
                        values.improvementsTotalCompBase += improvement.comp_base;
                        values.improvementsTotalCompLf += improvement.comp_lf;
                        values.improvementsTotalPerimeterAdj += improvement.perimeter_adj;
                        values.improvementsTotalLocationAdj += improvement.location_adj;
                        values.improvementsTotalAdjustedPPSF += improvement.adjustedPSF;
                        values.improvementsTotalAdjustedCost += (improvement.adjustedCost);

                        improvementsArray.push(improvement);
                    }
                }

            }

            values.improvements = improvementsArray;

            //Weight
            var costWeight = $('#cost-approach-percentage').attr('data-value');
            if (!isNotNull(costWeight)) {
                costWeight = 0;
            }

            //Total Depreciation Cost
            values.totalDepreciatedCost = values.overallReplacementCost - values.totalDepreciation;
            values.totalDepreciationPercentage = values.totalDepreciation / (values.overallReplacementCost !== 0 ? values.overallReplacementCost : 1);
            values.totalCostValuation = values.totalDepreciatedCost + values.landValue;
            values.totalIncrementalValue = values.totalCostValuation * (costWeight / 100);
            // values.indicatedValuePSF = values.totalCostValuation / buildingSize;
            values.indicatedValuePSF = (buildingSize > 0) ? values.totalCostValuation / buildingSize : 0;
            values.improvementsTotalDepreciation = values.totalDepreciationPercentage * 100;
            if ($('#comparison_basis_field').length) {
                let field_val = $('#total_' + $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase()).val();
                if (($('#comparison_basis_field').val() == 'Unit') && field_val > 0) {
                    values.indicatedValuePUnit = values.totalCostValuation / field_val;
                } else if (($('#comparison_basis_field').val() == 'Bed') && field_val > 0) {
                    values.indicatedValuePBed = values.totalCostValuation / field_val;
                }
            }
        }

        return values;
    }

    function getResLandValue(values, isAddDelete = 0) {
        let costFields = [];
        $('.label-value').each(function () {
            costFields.push($(this).attr('data-name'));
        });
        let compsEl = $('div.col.comps.comp-entry');

        let improvementsArray = [];
        let comps = values.comps;

        let totalPsf = 0;

        if (compsEl.length > 0) {
            compsEl.each(function (index, value) {
                // let id = $(value).find("input[name='evaluation[cost_approach][comps][index][id]']").val();
                let id = $(value).find("input[name='evaluation[cost_approach][comps][index][comp_id]']").val();

                if (id) {
                    comps[id] = {
                        totalAdjustment: 0,
                        salePrice: 0,
                        buildingSize: 0,
                        psf: 0,
                        adjustedPricePSF: 0,
                        weight: 0,
                        landDimension: 0,
                        index: 0
                    };

                    for (let key in costFields) {
                        if (costFields.hasOwnProperty(key)) {
                            let field;
                            if ($("#comp_adjustment_mode").val() == "Dollar") {
                                field = $(value).find("input[name='evaluation[cost_approach][comps][index][" + costFields[key] + "]']");
                            } else {
                                field = $(value).find("select[name='evaluation[cost_approach][comps][index][" + costFields[key] + "]']");
                                if (field.val() == 'Type My Own')
                                    field = $(value).find("input[name='evaluation[cost_approach][comps][index][" + costFields[key] + "_custom]']");
                            }

                            let field_val = 0;
                            if (field.val())
                                field_val = field.val().replace(/[^\d.-]/g, '');
                            if (field && isNotNull(field_val)) {
                                comps[id][costFields[key]] = parseFloat(field_val);
                                comps[id].totalAdjustment += comps[id][costFields[key]];
                            } else {
                                comps[id][costFields[key]] = 0;
                            }
                        }
                    }
                    $('.currency').maskMoney('mask');

                    var salePrice = $(value).find("input[name='single_comp[sale_price]']").val();
                    var buildingSize = $(value).find("input[name='single_comp[building_size]']").val();
                    var landSize = $(value).find("input[name='single_comp[land_size]']").val();
                    var landDimension = $(value).find("input[name='single_comp[land_dimension]']").val();
                    var indi_weight = $(value).find("input[name='evaluation[cost_approach][comps][index][weight]']").val();
                    if (indi_weight === "") {
                        indi_weight = 0;
                    }

                    if (isNotNull(salePrice) && isNotNull(buildingSize)) {
                        comps[id].salePrice = parseFloat(salePrice);
                        comps[id].buildingSize = parseFloat(buildingSize);
                        comps[id].landSize = parseFloat(landSize);
                        comps[id].indi_weight = parseFloat(indi_weight);

                        if (landDimension === 'ACRE') {
                            comps[id].landSize = comps[id].landSize * 43560;
                        } else {
                            comps[id].landSize = comps[id].landSize;
                        }
                        if (isInArray('cost', segments) && $("input[name='evaluation[landDimension]']").val() === 'ACRE') {
                            if (landDimension === 'ACRE') {
                                comps[id].landSize = parseFloat(landSize);
                            } else {
                                comps[id].landSize = (parseFloat(landSize) / 43560).toFixed(3);
                            }
                        }
                        let psf = (comps[id].salePrice / comps[id].landSize);
                        if (!comps[id].landSize) {
                            psf = 0;
                        }
                        if ($("#comp_adjustment_mode").val() == "Dollar") {
                            comps[id].adjustedPricePSF = psf + parseFloat(comps[id].totalAdjustment);
                        } else {
                            comps[id].adjustedPricePSF = psf * (1 + (parseFloat(comps[id].totalAdjustment) / 100));
                        }
                        comps[id].psf = comps[id].adjustedPricePSF;
                        // if(!comps[id].landSize){
                        //     comps[id].psf = 0;
                        //     comps[id].adjustedPricePSF = 0;
                        // }
                        values.totalAdjustedPrice += (comps[id].psf.toFixed(2)) * (comps[id].indi_weight / 100);

                        totalPsf += comps[id].adjustedPricePSF;
                    }
                    //Weight
                    var weightFieldEl = $(value).find("input[name='evaluation[cost_approach][comps][index][weight]']");
                    if (weightFieldEl.length) {
                        if ($(weightFieldEl).val() && $(weightFieldEl).val().length) {
                            var weightField = $(weightFieldEl).val().replace(/,/g, '.');
                            if (weightField.length) {
                                comps[id].weight = parseFloat(weightField);
                                $(weightFieldEl).val(comps[id].weight + "%");
                            }
                        }
                    }
                    //Total weights
                    values.totalWeights += comps[id].weight;
                }
                comps[id].index = index;
            });
            if (isAddDelete === 1) {
                values.totalAdjustedPrice = totalPsf / compsEl.length;
            }
            var current = $('.comp-current');
            current.find('span.current_averaged_adjusted_psf').text(mask(Utils.roundup(values.totalAdjustedPrice)));
            current.find("input[name='evaluation[cost_approach][averaged_adjusted_psf]']").val(values.totalAdjustedPrice);

            var compCount = compsEl.length;
            var w = 100 / compCount;
            var updated = false;

            var allWeight = [];

            var needToSplit = false;

            Object.keys(comps).forEach(function (item) {
                if (comps[item].weight != w) {
                    updated = true;
                }
                allWeight.push(comps[item].weight);

                if (comps[item].index + 1 == compCount) {
                    if (comps[item].weight == 0) {
                        needToSplit = true;
                    }
                }
            });

            if (needToSplit) {
                const index = allWeight.indexOf(0);
                if (index > -1) {
                    allWeight.splice(index, 1);
                }
            }

            if (allWeight.length == 0 && values.totalWeights == 0) {
                updated = false;
                values.totalWeights = 100;
            }

            if (allWeight.every((val, i, arr) => val === arr[0]) && values.totalWeights == 100) {
                updated = false;
                values.totalWeights = 100;
            }

            if (isAddDelete == 1) {
                updated = false;
                values.totalWeights = 100;
            }

            if (allWeight.length == 3) {

                let count = 0;
                allWeight.forEach(e => {
                    if (e == 33.33 || e == 33.34)
                        count++;
                });

                if (count == 3) {
                    updated = false;
                    values.totalWeights = 100;
                }
            }

            if (updated == false) {
                var weightFieldEl = $('div.col.comps.comp-entry').find("input[name='evaluation[cost_approach][comps][index][weight]']");

                $(weightFieldEl).val(w + "%");
                if (w.toFixed(2) == 33.33) {
                    $(weightFieldEl).val(w.toFixed(2) + "%");
                    $("input[name='evaluation[cost_approach][comps][index][weight]']:nth(2)").val("33.34%");
                }
            }

            var button = $('button.evaluations-next');
            var currentWeight = $('.current_weight').parent('.field');

            $("input[name='evaluation[cost_approach][weight]']").val(values.totalWeights);
            $(".current_weight").html(values.totalWeights.toFixed(2));

            if ((values.totalWeights !== 100)) {
                button.attr('disabled', 'disabled');

                currentWeight.addClass('error');
            } else {
                button.attr('disabled', false);
                currentWeight.removeClass('error');
            }

        }

        //Land size
        var landSize = 0.0;
        $('.comp-current').each(function (index, obj) {
            var sizeInput = $(obj).find('input[name="current[land_size]"]');

            if (sizeInput && sizeInput.val() > 0) {
                var val = parseFloat(sizeInput.val());
                var dimensionInput = $(obj).find('input[name="current[land_dimension]"]');

                if (dimensionInput && dimensionInput.val().length > 0) {
                    if (dimensionInput.val() === 'SF') {
                        if (!isNaN(val)) {
                            landSize += val;
                        }
                    } else if (dimensionInput.val() === 'ACRE') {
                        if (!isNaN(val)) {
                            // if(isInArray('cost', segments) && $("#comp_adjustment_mode").val() == 'Dollar'){
                            landSize += val; //convert to ACRE
                            // }else{
                            //     landSize += val * 43560; //convert to SF
                            // }
                        }
                    }
                } else {
                    if (!isNaN(val)) {
                        landSize += val;
                    }
                }
            }
        });

        values.landSize = landSize;

        //Land Value
        if (!isNaN(parseFloat(values.totalAdjustedPrice))) {
            values.landValue = parseFloat(landSize) * values.totalAdjustedPrice.toFixed(2);
        }

        var buildingSize = parseFloat($("input[name='current[building_size]']").val());

        if (!isNaN(parseFloat(values.totalAdjustedPrice)) && !isNaN(parseFloat(values.landValue))) {
            if ($('#cost-data').html().length > 0) {
                var jsonresponse = $('#cost-data').html();
                var response = JSON.parse(jsonresponse);
                for (var i in response.improvements) {
                    if (response.improvements.hasOwnProperty(i)) {
                        var improvement = response.improvements[i];

                        improvement.adjustedPSF = 0;
                        improvement.structureCost = 0;
                        improvement.depreciationAmount = 0;
                        improvement.adjustedCost = 0;
                        improvement.comp_base = get_number(improvement.comp_base);
                        improvement.comp_lf = get_number(improvement.comp_lf);
                        improvement.subject_lf = get_number(improvement.subject_lf);
                        improvement.perimeter_adj = get_number(improvement.perimeter_adj);
                        improvement.location_adj = get_number(improvement.location_adj);
                        improvement.depreciation = get_number(improvement.depreciation);
                        improvement.sf_area = get_number(improvement.sf_area);

                        //Adjusted PSF
                        if (response.type === 'advanced') {
                            var adjustedPPSF = (improvement.comp_base - (improvement.comp_lf - improvement.subject_lf) * (improvement.perimeter_adj / 100)) * (0.89 - (improvement.location_adj / 100));
                            improvement.adjustedPSF = get_number(adjustedPPSF);
                        } else {
                            improvement.adjustedPSF = get_number(improvement.adjusted_psf);
                        }

                        //Structure Cost
                        improvement.structureCost = improvement.adjustedPSF * improvement.sf_area;

                        //Depreciation Amount
                        improvement.depreciationAmount = improvement.structureCost * (improvement.depreciation / 100);

                        //Adjusted Cost
                        improvement.adjustedCost = improvement.structureCost - improvement.depreciationAmount;

                        //Overall Replacement Cost
                        values.overallReplacementCost += improvement.structureCost;

                        //Total Depreciation
                        values.totalDepreciation += improvement.depreciationAmount;

                        values.improvementsTotalSfArea += improvement.sf_area;
                        values.improvementsTotalSubjectLf += improvement.subject_lf;
                        values.improvementsTotalCompBase += improvement.comp_base;
                        values.improvementsTotalCompLf += improvement.comp_lf;
                        values.improvementsTotalPerimeterAdj += improvement.perimeter_adj;
                        values.improvementsTotalLocationAdj += improvement.location_adj;
                        values.improvementsTotalAdjustedPPSF += improvement.adjustedPSF;
                        values.improvementsTotalAdjustedCost += (improvement.adjustedCost);

                        improvementsArray.push(improvement);
                    }
                }

            }

            values.improvements = improvementsArray;

            //Weight
            var costWeight = $('#cost-approach-percentage').attr('data-value');
            if (!isNotNull(costWeight)) {
                costWeight = 0;
            }

            //Total Depreciation Cost
            values.totalDepreciatedCost = values.overallReplacementCost - values.totalDepreciation;
            values.totalDepreciationPercentage = values.totalDepreciation / (values.overallReplacementCost !== 0 ? values.overallReplacementCost : 1);
            values.totalCostValuation = values.totalDepreciatedCost + values.landValue;
            values.totalIncrementalValue = values.totalCostValuation * (costWeight / 100);
            values.indicatedValuePSF = (buildingSize > 0) ? values.totalCostValuation / buildingSize : 0;
            values.improvementsTotalDepreciation = values.totalDepreciationPercentage * 100;
        }
        return values;
    }

    /**
     * Calculate the Total Cost Valuation for the cost approach.
     * @param values
     * @returns {*}
     */
    function getTotalCostValuation(values) {
        var type = $('select[name="evaluation[cost_approach_improvement][type]"]').val();

        var costImprovementFields = ['sf_area', 'subject_lf', 'adjusted_psf', 'comp_base', 'comp_lf', 'perimeter_adj', 'location_adj', 'depreciation', 'custom_sf_total_area', 'sf_area'];

        if (type === 'advanced') {
            costImprovementFields = ['sf_area', 'subject_lf', 'comp_base', 'comp_lf', 'perimeter_adj', 'location_adj', 'depreciation'];
        }

        var improvementsCount = 0;
        var improvementsEntries = $('div.cost-approach-improvement-entry');
        var costImprovements = {};

        improvementsEntries.each(function (index, value) {
            costImprovements[improvementsCount] = {
                adjustedPSF: 0,
                structureCost: 0,
                depreciationAmount: 0,
                adjustedCost: 0
            };

            //Extract amounts
            for (var key in costImprovementFields) {
                if (costImprovementFields.hasOwnProperty(key)) {
                    var field = $(value).find("input[name='evaluation[cost_approach_improvement][improvements][index][" + costImprovementFields[key] + "]']");
                    var isCountable = true;
                    if (!field.hasClass('disabled-improvement')) {
                        isCountable = false;
                    }

                    if (field.attr('name') == 'evaluation[cost_approach_improvement][improvements][index][sf_area]' && field.hasClass('count-total-sf-area')) {
                        var sffieldValue = getValue(field[0]);
                        if (isNotNull(sffieldValue)) {
                            costImprovements[improvementsCount].custom_sf_total_area = sffieldValue;
                        } else {
                            costImprovements[improvementsCount].custom_sf_total_area = 0;
                        }
                    }
                    if (field && field.val()) {
                        var fieldValue = getValue(field[0]);
                        if (!isCountable) {
                            fieldValue = 0;
                        }

                        if (typeof (fieldValue) === 'string') {
                            fieldValue = parseFloat(fieldValue);
                        }

                        if (isNotNull(fieldValue)) {
                            costImprovements[improvementsCount][costImprovementFields[key]] = fieldValue;
                        } else {
                            costImprovements[improvementsCount][costImprovementFields[key]] = 0;
                        }
                    } else {
                        costImprovements[improvementsCount][costImprovementFields[key]] = 0;
                    }
                }

                costImprovements[improvementsCount].object = $(value);
            }

            improvementsCount++;
        });
        values.improvements = costImprovements;

        for (var improvementIndex in costImprovements) {
            var improvement = costImprovements[improvementIndex];

            //Calculating Adjusted PSF for Improvement
            if (type === 'advanced') {
                improvement.adjustedPSF = (improvement.comp_base - (improvement.comp_lf - improvement.subject_lf) * (improvement.perimeter_adj / 100)) * (0.89 - (improvement.location_adj / 100));
            } else {
                improvement.adjustedPSF = improvement.adjusted_psf;
            }

            //Calculating structure cost for Improvement
            improvement.structureCost = improvement.adjustedPSF * improvement.sf_area;

            //Calculating Depreciation Amount for Improvement
            improvement.depreciationAmount = improvement.structureCost * (improvement.depreciation / 100);

            //Calculating Structure Cost for Improvement
            improvement.adjustedCost = improvement.structureCost - improvement.depreciationAmount;

            //Calculating Total Overall Replacement Cost
            values.overallReplacementCost = values.overallReplacementCost + improvement.structureCost;

            //Calculating Total Depreciation
            values.totalDepreciation = values.totalDepreciation + improvement.depreciationAmount;
            values.totalstructureCost = values.totalstructureCost + improvement.structureCost;
            // value.totalNewDepreciation = (improvement.depreciationAmount)
            values.improvementsTotalSfArea += parseInt(improvement.custom_sf_total_area);
            values.improvementsTotalSubjectLf += improvement.subject_lf;
            values.improvementsTotalCompBase += improvement.comp_base;
            values.improvementsTotalCompLf += improvement.comp_lf;
            values.improvementsTotalPerimeterAdj += improvement.perimeter_adj;
            values.improvementsTotalLocationAdj += improvement.location_adj;
            values.improvementsTotalAdjustedPPSF += improvement.adjustedPSF;
            values.improvementsTotalAdjustedCost += improvement.adjustedCost;
            values.totalNewAdjustedCost += improvement.structureCost;
        }

        var buildingSize = parseFloat($("input[name='building_size']").val());
        if (!isNaN(parseFloat(values.overallReplacementCost)) && !isNaN(parseFloat(values.totalDepreciation))) {
            var response = JSON.parse($('#cost-data').html());

            if (!isNaN(parseFloat(response.land_value)) && !isNaN(parseFloat(response.averaged_adjusted_psf))) {
                values.landValue = parseFloat(response.land_value);
                values.totalAdjustedPrice = parseFloat(response.averaged_adjusted_psf);
            }
            var costWeight = $('#cost-approach-percentage').attr('data-value');

            if (!isNotNull(costWeight)) {
                costWeight = 0;
            }

            //Total Depreciation Cost
            values.totalDepreciatedCost = values.overallReplacementCost - values.totalDepreciation;
            values.totalDepreciationPercentage = values.totalDepreciation / (values.overallReplacementCost !== 0 ? values.overallReplacementCost : 1);
            values.totalCostValuation = values.totalDepreciatedCost + values.landValue;
            values.totalIncrementalValue = values.totalCostValuation * (costWeight / 100);
            values.indicatedValuePSF = values.totalCostValuation / (values.improvementsTotalSfArea !== 0 ? values.improvementsTotalSfArea : 1);
            if ($('#comparison_basis_field').length) {
                let field_val = $('#total_' + $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase()).val();
                if (($('#comparison_basis_field').val() == 'Unit') && field_val > 0) {
                    values.indicatedValuePUnit = values.totalCostValuation / field_val;
                } else if (($('#comparison_basis_field').val() == 'Bed') && field_val > 0) {
                    values.indicatedValuePBed = values.totalCostValuation / field_val;
                }
            }
            values.improvementsTotalDepreciation = (values.totalDepreciation / values.totalNewAdjustedCost) * 100;
            values.improvementsTotalAdjustedPPSF = values.improvementsTotalAdjustedCost / (values.improvementsTotalSfArea !== 0 ? values.improvementsTotalSfArea : 1);
            // }
        }

        return values;
    }

    var setCostValues = function (obj) {
        if (obj !== undefined) {
            var current = $('.comp-current');

            current.find('span.current_weight').text(mask(obj.totalWeights)); //View
            current.find("input[name='evaluation[cost_approach][weight]']").val(obj.totalWeights);

            // if(isInArray('cost', segments) !== -1 && $("input[name='evaluation[landDimension]']").val() === 'ACRE' && $("#comp_adjustment_mode").val() == 'Percent'){
            //     current.find('span.current_averaged_adjusted_psf').text(mask(Utils.roundup(obj.totalAdjustedPrice*43560)));
            // }else{
            current.find('span.current_averaged_adjusted_psf').text(mask(Utils.roundup(obj.totalAdjustedPrice)));
            // }
            current.find("input[name='evaluation[cost_approach][averaged_adjusted_psf]']").val(obj.totalAdjustedPrice);
            current.find('span.land_value').text((obj.landValue) ? "$" + mask(Utils.roundup(obj.landValue)) : 'N/A');
            current.find("input[name='evaluation[cost_approach][land_value]']").val(obj.landValue);

            current.find("input[name='evaluation[cost_approach][incremental_value]']").val(obj.totalIncrementalValue);
            for (var id in obj.comps) {
                if (obj.comps.hasOwnProperty(id)) {
                    var comp = obj.comps[id];
                    var el = $('.comp-entry[data-id=' + id + ']');

                    if ($("#comp_adjustment_mode").val() == "Dollar") {
                        el.find('span.total-adjustment').text((comp.totalAdjustment < 0 ? '-$' : '$') + mask(Math.abs(comp.totalAdjustment))); //View
                    } else {
                        el.find('span.total-adjustment').text(mask(comp.totalAdjustment)); //View
                    }
                    el.find("input[name='evaluation[cost_approach][comps][index][total_adjustment]']").val(comp.totalAdjustment);

                    // if(isInArray('cost', segments) && $("input[name='evaluation[landDimension]']").val() === 'ACRE' && $("#comp_adjustment_mode").val() == 'Percent'){
                    //     el.find('span.adjusted_psf').text(mask(parseFloat(comp.adjustedPricePSF).toFixed(2)*43560));
                    // }else{
                    el.find('span.adjusted_psf').text(mask(comp.adjustedPricePSF));
                    // }
                    el.find("input[name='evaluation[cost_approach][comps][index][adjusted_psf]']").val(comp.adjustedPricePSF);
                }
            }

            var type = $('select[name="evaluation[cost_approach_improvement][type]"]').val();
            for (var i in obj.improvements) {
                if (obj.improvements.hasOwnProperty(i)) {
                    var improvement = obj.improvements[i];

                    if (improvement.object) {
                        improvement.object.find("input[name='evaluation[cost_approach_improvement][improvements][index][structure_cost]']").val(improvement.structureCost);
                        improvement.object.find("input[name='evaluation[cost_approach_improvement][improvements][index][depreciation_amount]']").val(improvement.depreciationAmount);
                        improvement.object.find("input[name='evaluation[cost_approach_improvement][improvements][index][adjusted_cost]']").val('$' + mask(improvement.adjustedCost));

                        if (type === 'advanced') {
                            improvement.object.find("input[name='evaluation[cost_approach_improvement][improvements][index][adjusted_psf]']").val('$' + formatNumber(improvement.adjustedPSF));
                        }
                    }
                }
            }

            $("input[name='evaluation[cost_approach_improvement][overall_replacement_cost]']").val(obj.overallReplacementCost);
            $("input[name='evaluation[cost_approach_improvement][total_depreciation]']").val(obj.totalDepreciation);
            $("input[name='evaluation[cost_approach_improvement][total_depreciation_percentage]']").val(obj.totalDepreciationPercentage);
            $("input[name='evaluation[cost_approach_improvement][total_depreciated_cost]']").val(obj.totalDepreciatedCost);
            $("input[name='evaluation[cost_approach_improvement][total_cost_valuation]']").val(obj.totalCostValuation);
            $("input[name='evaluation[cost_approach_improvement][indicated_value_psf]']").val(obj.indicatedValuePSF);
            if ($('#comparison_basis_field').length) {
                let field_name = 'indicated_value_p' + $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase();
                if ($('#comparison_basis_field').val() == 'Unit') {
                    // $("input[name='evaluation[cost_approach_improvement][totals]["+field_name+"]']").val(obj.indicatedValuePUnit);
                    $("input[name='evaluation[cost_approach_improvement][" + field_name + "]']").val(obj.indicatedValuePUnit);
                } else if ($('#comparison_basis_field').val() == 'Bed') {
                    // $("input[name='evaluation[cost_approach_improvement][totals]["+field_name+"]']").val(obj.indicatedValuePBed);
                    $("input[name='evaluation[cost_approach_improvement][" + field_name + "]']").val(obj.indicatedValuePBed);
                }
            }

            $("#land_value").text('$' + mask(obj.landValue));
            $("#total_cost_valuation").text('$' + mask(obj.totalCostValuation));
            $("#indicated_value_psf").text('$' + mask(obj.indicatedValuePSF));
            if ($('#comparison_basis_field').length) {
                let field_id = 'indicated_value_p' + $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase();
                if ($('#comparison_basis_field').val() == 'Unit') {
                    $("#" + field_id).text('$' + mask(obj.indicatedValuePUnit));
                } else if ($('#comparison_basis_field').val() == 'Bed') {
                    $("#" + field_id).text('$' + mask(obj.indicatedValuePBed));
                }
            }
            $("#improvementsTotalSfArea").text(maskUnit(obj.improvementsTotalSfArea));
            $("#improvementsTotalSubjectLf").text(obj.improvementsTotalSubjectLf);
            $("#improvementsTotalCompBase").text('$' + mask(obj.improvementsTotalCompBase));
            $("#improvementsTotalCompLf").text(obj.improvementsTotalCompLf);
            $("#improvementsTotalPerimeterAdj").text('$' + mask(obj.improvementsTotalPerimeterAdj));
            $("#improvementsTotalLocationAdj").text(mask(obj.improvementsTotalLocationAdj) + "%");
            $("#improvementsTotalAdjustedPPSF").text('$' + mask(obj.improvementsTotalAdjustedPPSF));
            $("#improvementsTotalDepreciation").text(mask(obj.improvementsTotalDepreciation) + '%');
            $("#improvementsTotalAdjustedCost").text('$' + mask(obj.improvementsTotalAdjustedCost));
            $(".improvementsTotalAdjustedCost").text('$' + mask(obj.improvementsTotalAdjustedCost));

            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_sf_area]']").val(obj.improvementsTotalSfArea);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_subject_lf]']").val(obj.improvementsTotalSubjectLf);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_comp_base]']").val(obj.improvementsTotalCompBase);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_comp_lf]']").val(obj.improvementsTotalPerimeterAdj);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_perimeter_adj]']").val(obj.improvementsTotalPerimeterAdj);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_location_adj]']").val(obj.improvementsTotalLocationAdj);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_adjusted_ppsf]']").val(obj.improvementsTotalAdjustedPPSF);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_depreciation]']").val(obj.improvementsTotalDepreciation);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_adjusted_cost]']").val(obj.improvementsTotalAdjustedCost);

            $("input[name='evaluation[cost_approach_improvement][improvements_total_sf_area]']").val(obj.improvementsTotalSfArea);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_subject_lf]']").val(obj.improvementsTotalSubjectLf);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_comp_base]']").val(obj.improvementsTotalCompBase);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_comp_lf]']").val(obj.improvementsTotalPerimeterAdj);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_perimeter_adj]']").val(obj.improvementsTotalPerimeterAdj);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_location_adj]']").val(obj.improvementsTotalLocationAdj);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_adjusted_ppsf]']").val(obj.improvementsTotalAdjustedPPSF);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_depreciation]']").val(obj.improvementsTotalDepreciation);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_adjusted_cost]']").val(obj.improvementsTotalAdjustedCost);
        }
    };

    var setResCostValues = function (obj) {
        if (obj !== undefined) {
            var current = $('.comp-current');

            current.find('span.current_weight').text(mask(obj.totalWeights)); //View
            current.find("input[name='evaluation[cost_approach][weight]']").val(obj.totalWeights);

            // if(isInArray('cost', segments) !== -1 && $("input[name='evaluation[landDimension]']").val() === 'ACRE' && $("#comp_adjustment_mode").val() == 'Percent'){
            //     current.find('span.current_averaged_adjusted_psf').text(mask(Utils.roundup(obj.totalAdjustedPrice*43560)));
            // }else{
            current.find('span.current_averaged_adjusted_psf').text(mask(Utils.roundup(obj.totalAdjustedPrice)));
            // }
            current.find("input[name='evaluation[cost_approach][averaged_adjusted_psf]']").val(obj.totalAdjustedPrice);

            // current.find('span.land_value').text(mask(Utils.roundup(obj.landValue)));
            current.find('span.land_value').text((obj.landValue) ? "$" + mask(Utils.roundup(obj.landValue)) : 'N/A');
            current.find("input[name='evaluation[cost_approach][land_value]']").val(obj.landValue);

            current.find("input[name='evaluation[cost_approach][incremental_value]']").val(obj.totalIncrementalValue);
            for (var id in obj.comps) {
                if (obj.comps.hasOwnProperty(id)) {
                    var comp = obj.comps[id];
                    var el = $('.comp-entry[data-id=' + id + ']');

                    if ($("#comp_adjustment_mode").val() == "Dollar") {
                        el.find('span.total-adjustment').text((comp.totalAdjustment < 0 ? '-$' : '$') + mask(Math.abs(comp.totalAdjustment))); //View
                    } else {
                        el.find('span.total-adjustment').text(mask(comp.totalAdjustment)); //View
                    }
                    el.find("input[name='evaluation[cost_approach][comps][index][total_adjustment]']").val(comp.totalAdjustment);

                    // if(isInArray('cost', segments) && $("input[name='evaluation[landDimension]']").val() === 'ACRE' && $("#comp_adjustment_mode").val() == 'Percent'){
                    //     el.find('span.adjusted_psf').text(mask(parseFloat(comp.adjustedPricePSF).toFixed(2)*43560));
                    // }else{
                    //     el.find('span.adjusted_psf').text(mask(comp.adjustedPricePSF));
                    // }
                    el.find('span.adjusted_psf').text(mask(comp.adjustedPricePSF));
                    el.find("input[name='evaluation[cost_approach][comps][index][adjusted_psf]']").val(comp.adjustedPricePSF);
                }
            }

            var type = $('select[name="evaluation[cost_approach_improvement][type]"]').val();
            for (var i in obj.improvements) {
                if (obj.improvements.hasOwnProperty(i)) {
                    var improvement = obj.improvements[i];

                    if (improvement.object) {
                        improvement.object.find("input[name='evaluation[cost_approach_improvement][improvements][index][structure_cost]']").val(improvement.structureCost);
                        improvement.object.find("input[name='evaluation[cost_approach_improvement][improvements][index][depreciation_amount]']").val(improvement.depreciationAmount);
                        improvement.object.find("input[name='evaluation[cost_approach_improvement][improvements][index][adjusted_cost]']").val('$' + mask(improvement.adjustedCost));

                        if (type === 'advanced') {
                            improvement.object.find("input[name='evaluation[cost_approach_improvement][improvements][index][adjusted_psf]']").val('$' + formatNumber(improvement.adjustedPSF));
                        }
                    }
                }
            }

            $("input[name='evaluation[cost_approach_improvement][overall_replacement_cost]']").val(obj.overallReplacementCost);
            $("input[name='evaluation[cost_approach_improvement][total_depreciation]']").val(obj.totalDepreciation);
            $("input[name='evaluation[cost_approach_improvement][total_depreciation_percentage]']").val(obj.totalDepreciationPercentage);
            $("input[name='evaluation[cost_approach_improvement][total_depreciated_cost]']").val(obj.totalDepreciatedCost);
            $("input[name='evaluation[cost_approach_improvement][total_cost_valuation]']").val(obj.totalCostValuation);
            $("input[name='evaluation[cost_approach_improvement][indicated_value_psf]']").val(obj.indicatedValuePSF);
            $("#land_value").text('$' + mask(obj.landValue));
            $("#total_cost_valuation").text('$' + mask(obj.totalCostValuation));
            $("#indicated_value_psf").text('$' + mask(obj.indicatedValuePSF));
            $("#improvementsTotalSfArea").text(maskUnit(obj.improvementsTotalSfArea));
            $("#improvementsTotalSubjectLf").text(obj.improvementsTotalSubjectLf);
            $("#improvementsTotalCompBase").text('$' + mask(obj.improvementsTotalCompBase));
            $("#improvementsTotalCompLf").text(obj.improvementsTotalCompLf);
            $("#improvementsTotalPerimeterAdj").text('$' + mask(obj.improvementsTotalPerimeterAdj));
            $("#improvementsTotalLocationAdj").text(mask(obj.improvementsTotalLocationAdj) + "%");
            $("#improvementsTotalAdjustedPPSF").text('$' + mask(obj.improvementsTotalAdjustedPPSF));
            $("#improvementsTotalDepreciation").text(mask(obj.improvementsTotalDepreciation) + '%');
            $("#improvementsTotalAdjustedCost").text('$' + mask(obj.improvementsTotalAdjustedCost));
            $(".improvementsTotalAdjustedCost").text('$' + mask(obj.improvementsTotalAdjustedCost));
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_sf_area]']").val(obj.improvementsTotalSfArea);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_subject_lf]']").val(obj.improvementsTotalSubjectLf);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_comp_base]']").val(obj.improvementsTotalCompBase);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_comp_lf]']").val(obj.improvementsTotalPerimeterAdj);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_perimeter_adj]']").val(obj.improvementsTotalPerimeterAdj);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_location_adj]']").val(obj.improvementsTotalLocationAdj);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_adjusted_ppsf]']").val(obj.improvementsTotalAdjustedPPSF);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_depreciation]']").val(obj.improvementsTotalDepreciation);
            // $("input[name='evaluation[cost_approach_improvement][totals][improvements_total_adjusted_cost]']").val(obj.improvementsTotalAdjustedCost);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_sf_area]']").val(obj.improvementsTotalSfArea);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_subject_lf]']").val(obj.improvementsTotalSubjectLf);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_comp_base]']").val(obj.improvementsTotalCompBase);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_comp_lf]']").val(obj.improvementsTotalPerimeterAdj);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_perimeter_adj]']").val(obj.improvementsTotalPerimeterAdj);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_location_adj]']").val(obj.improvementsTotalLocationAdj);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_adjusted_ppsf]']").val(obj.improvementsTotalAdjustedPPSF);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_depreciation]']").val(obj.improvementsTotalDepreciation);
            $("input[name='evaluation[cost_approach_improvement][improvements_total_adjusted_cost]']").val(obj.improvementsTotalAdjustedCost);
        }
    };

    var setSidebar = function (obj, save = 0) {
        var d1 = setIncomeSidebar(obj);
        var d2 = setSalesSidebar(obj);
        var d3 = setCostSidebar(obj);

        $.when(d1, d2, d3).then(function (res1, res2, res3) {
            var values = {
                indicatedValueAnnual: 0,
                salesApproachValue: 0,
                totalCostValuation: 0
            };

            var data1 = !isNaN(res1) ? { income_approach_value: res1 } : JSON.parse(res1[0]);
            if (isNotNull(data1.income_approach_value)) {
                values.indicatedValueAnnual = parseFloat(data1.income_approach_value);
            }

            var data2 = !isNaN(res2) ? { sales_approach_value: res2 } : JSON.parse(res2[0]);
            if (isNotNull(data2.sales_approach_value)) {
                values.salesApproachValue = parseFloat(data2.sales_approach_value);
            }

            var data3 = !isNaN(res3) ? { final: { total_cost_valuation: res3 } } : JSON.parse(res3[0]);
            if (data3.final && isNotNull(data3.final.total_cost_valuation)) {
                values.totalCostValuation = parseFloat(data3.final.total_cost_valuation);
            }

            setWeight(values, save);

            // if ((location.pathname.indexOf('/income') == -1) && (location.pathname.indexOf('/sales') == -1) && (location.pathname.indexOf('/cost') == -1)) {
            //     save();
            // }
        });
    };

    var setIncomeSidebar = function (obj) {
        if (obj && obj.indicatedValuePSF && obj.indicatedValuePSF.annual > 0 && obj.indicatedValueRange && obj.indicatedValueRange.annual > 0) {
            var incomeApproach = $('.income-approach-sidebar');

            if (incomeApproach.data('hide-cents')) {
                $('.income-approach-sidebar').removeClass('hide');

                $('#income-approach-total-lg').text(mask(obj.indicatedValueRange.annual, true));
                $('#income-approach-incremental-value').text(mask(obj.incrementalValue.annual, true));
                $('#income-approach-psf').text(mask(obj.indicatedValuePSF.annual, true));
            } else {
                $('.income-approach-sidebar').removeClass('hide');

                $('#income-approach-total-lg').text(mask(obj.indicatedValueRange.annual));
                $('#income-approach-incremental-value').text(mask(obj.incrementalValue.annual));
                $('#income-approach-psf').text(mask(obj.indicatedValuePSF.annual));
            }

            var defer = $.Deferred();
            defer.promise(obj.indicatedValueRange.annual);
            defer.resolve(obj.indicatedValueRange.annual);

            return defer;
        } else {
            let url = 'evaluations/get_income_approach';
            if (location.pathname.indexOf('/res_evaluations') !== -1)
                url = 'res_evaluations/get_income_approach';
            return $.ajax({
                type: "GET",
                url: $("body").data("base-url") + url,
                data: {
                    'id': $('input[name="evaluation_income_approaches[id]"]').val()
                },
                success: function (responseText) {
                    var response = JSON.parse(responseText);
                    if (response.status === 'success') {
                        $('.income-approach-sidebar').removeClass('hide');

                        var indicatedValueAnnual = parseFloat(response.income_approach_value);
                        var incrementalValue = parseFloat(response.incremental_approach_value);
                        var indicatedValueAnnualPSF = parseFloat(response.income_approach_psf);

                        $('#income-approach-total-lg').text(mask(indicatedValueAnnual, true));
                        $('#income-approach-incremental-value').text(mask(incrementalValue, true));
                        $('#income-approach-psf').text(mask(indicatedValueAnnualPSF, true));

                    } else {
                        $('.income-approach-sidebar').addClass('hide');
                    }
                }
            });
        }
    };

    var setSalesSidebar = function (obj) {
        if (obj && obj.value >= 0 && obj.totalAverageAdjusted >= 0) {
            if (obj.value == 0 && obj.totalAverageAdjusted == 0) {
                $('.sales-approach-sidebar').addClass('hide');
            } else {
                $('.sales-approach-sidebar').removeClass('hide');
            }
            let finalValue = 0;
            let resFinalValue = 0;

            if ((location.pathname.indexOf('/res_evaluations') == -1) && $('#comparison_basis_field').val() != 'SF') {
                let comparison_val = $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase();
                sqftValue = $('#comparison_basis_' + comparison_val + '_value').val();
                finalValue += getTotalSalesValue((obj.totalAverageAdjusted).toFixed(2), sqftValue);
            } else {
                $('.data').each(function () {
                    sqftValue = $(this).find('.sqft_value').val();
                    weightValue = $(this).find('.weightsf_value').val();
                    if (location.pathname.indexOf('/res_evaluations') !== -1) {
                        resFinalValue += getResTotalSalesValue(obj.totalAverageAdjusted, sqftValue, weightValue);
                    } else {
                        finalValue += getTotalSalesValue((obj.totalAverageAdjusted).toFixed(2), sqftValue, weightValue);
                    }
                });
            }
            if ($('#selected_comp_type').val() === 'land_only') {
                $('#sales-approach-total-lg').text(mask(obj.value, true));
            } else {
                if (location.pathname.indexOf('/res_evaluations') !== -1) {
                    $('#sales-approach-total-lg').text(mask(resFinalValue, true));
                } else {
                    $('#sales-approach-total-lg').text(mask(finalValue, true));
                }
            }
            $('#sales-approach-incremental-value').text(mask(obj.incrementalValue, true));
            $('#sales-approach-psf').text(mask(obj.totalAverageAdjusted, true));

            var defer = $.Deferred();
            defer.promise(obj.value);
            defer.resolve(obj.value);

            return defer;
        } else {
            let url = 'evaluations/get_sales_approach';
            if (location.pathname.indexOf('/res_evaluations') !== -1)
                url = 'res_evaluations/get_sales_approach';
            return $.ajax({
                type: "GET",
                url: $("body").data("base-url") + url,
                data: { 'id': $('input[name="evaluation_sales_approaches[id]"]').val() },
                success: function (responseText) {
                    var response = JSON.parse(responseText);

                    if (response.status === 'success') {
                        $('.sales-approach-sidebar').removeClass('hide');

                        var salesApproachValue = parseFloat(response.sales_approach_value);
                        var incrementalValue = parseFloat(response.incremental_value);
                        var totalAverageAdjusted = parseFloat(response.sales_approach_psf);

                        $('#sales-approach-total-lg').text(mask(salesApproachValue, true));
                        $('#sales-approach-incremental-value').text(mask(incrementalValue, true));
                        $('#sales-approach-psf').text(mask(totalAverageAdjusted, true));
                    } else {
                        $('.sales-approach-sidebar').addClass('hide');
                    }
                }
            });
        }
    };

    var setCostSidebar = function (obj) {
        if (obj && obj.totalCostValuation >= 0 && obj.indicatedValuePSF >= 0) {
            $('.cost-approach-sidebar').removeClass('hide');
            $('#cost-approach-total-lg').text(mask(obj.totalCostValuation, true));
            $('#cost-approach-incremental-value').text(mask(obj.totalIncrementalValue, true));
            $('#cost-approach-psf').text(mask(obj.indicatedValuePSF, true));
            if ($('#comparison_basis_field').length) {
                if ($('#comparison_basis_field').val() == 'Unit') {
                    $('#cost-approach-psf').text(mask(obj.indicatedValuePUnit, true));
                } else if ($('#comparison_basis_field').val() == 'Bed') {
                    $('#cost-approach-psf').text(mask(obj.indicatedValuePBed, true));
                }
            }

            var defer = $.Deferred();
            defer.promise(obj.totalCostValuation);
            defer.resolve(obj.totalCostValuation);

            return defer;
        } else {
            let url = 'evaluations/get_cost_approach';
            if (location.pathname.indexOf('/res_evaluations') !== -1)
                url = 'res_evaluations/get_cost_approach';
            return $.ajax({
                type: "GET",
                url: $("body").data("base-url") + url,
                data: { 'id': $('input[name="evaluation_cost_approaches[id]"]').val() },
                success: function (responseText) {
                    var response = JSON.parse(responseText);

                    if (Utils.contains(response.status, 'success') && response.final.total_cost_valuation && response.final.indicated_value_psf) {
                        $('#cost-approach-total-lg').text(mask(parseFloat(response.final.total_cost_valuation), true));
                        $('#cost-approach-incremental-value').text(mask(parseFloat(response.approach.incremental_value), true));
                        let cost_approach_psf = mask(parseFloat(response.final.indicated_value_psf), true);
                        if ($('#comparison_basis_field').length) {
                            if ($('#comparison_basis_field').val() == 'Unit') {
                                cost_approach_psf = (response.approach.indicated_value_punit) ? mask(parseFloat(response.approach.indicated_value_punit), true) : mask(0);
                            } else if ($('#comparison_basis_field').val() == 'Bed') {
                                cost_approach_psf = (response.approach.indicated_value_pbed) ? mask(parseFloat(response.approach.indicated_value_pbed), true) : mask(0);
                            }
                        }
                        $('#cost-approach-psf').text(cost_approach_psf);
                        totalCostValuation = response.final.total_cost_valuation;
                    } else {
                        $('.cost-approach-sidebar').addClass('hide');
                    }
                }
            }); ``
        }
    };

    var setWeight = function (obj, save = 0) {
        //Income Approach
        var incomeWeight = $('#income-approach-percentage').attr('data-value');
        if (!isNotNull(incomeWeight)) {
            incomeWeight = 0;
        }
        var incomeIncrementalValue = (incomeWeight / 100) * obj.indicatedValueAnnual;

        //Sales Approach
        var salesWeight = $('#sales-approach-percentage').attr('data-value');
        if (!isNotNull(salesWeight)) {
            salesWeight = 0;
        }
        var salesIncrementalValue = (salesWeight / 100) * obj.salesApproachValue;

        //Cost Approach
        var costWeight = $('#cost-approach-percentage').attr('data-value');
        if (!isNotNull(costWeight)) {
            costWeight = 0;
        }
        var costIncrementalValue = (costWeight / 100) * obj.totalCostValuation;

        var weightedValue = incomeIncrementalValue + salesIncrementalValue + costIncrementalValue;

        if (isNotNull(weightedValue)) {
            var buildingSize = $("input[name='evaluation[building_size]']").val();
            var landSize = $("input[name='evaluation[land_size]']").val();
            var landDimension = $("input[name='evaluation[landDimension]']").val();
            var total_weight_psf = 0;
            if ($("#selected_comp_type").val() == "land_only") {
                if (landDimension === 'ACRE' && $('#selected_analysis_type').val() !== '$/Acre') {
                    landSize = landSize * 43560;
                } else {
                    landSize = landSize;
                }
                total_weight_psf = parseFloat(weightedValue) / parseFloat(landSize);
            } else if (buildingSize > 0) {
                total_weight_psf = parseFloat(weightedValue) / parseFloat(buildingSize);
                if ($('#comparison_basis_field').length) {
                    let comparison_val = $('#comparison_basis_field').val().replace(/ /g, "_").toLowerCase();
                    let devide_by = $('#comparison_basis_' + comparison_val + '_value').val();
                    if ($('#comparison_basis_field').val() == 'Unit') {
                        total_weight_psf = parseFloat(weightedValue) / parseFloat(devide_by);
                    } else if ($('#comparison_basis_field').val() == 'Bed') {
                        total_weight_psf = parseFloat(weightedValue) / parseFloat(devide_by);
                    }
                }
            }
            $('span#weighted-value').text(mask(weightedValue, true));
            $('#weighted-value-input').val(weightedValue);
            total_weight_psf <= 10 ? $('#total-weight-psf').text(mask(total_weight_psf)) : $('#total-weight-psf').text(mask(total_weight_psf, true));
        } else {
            $('span#weighted-value').text(mask(0, true));
            $('#weighted-value-input').val(0);
            $('#total-weight-psf').text(mask(0, true));
            weightedValue = 0;
        }

        updateEvaluation(incomeIncrementalValue, salesIncrementalValue, costIncrementalValue, weightedValue, save);

        // EvaluationsCommons.saveEvalTotalWeight();
    };

    var updateEvaluation = function (income, sales, cost, weighted, save = 0) {
        var form = $("#weight-form");
        var approach = form.find('[name=approach]').val();

        var data = {
            'evaluation': {
                'id': form.find('input[name=id]').val(),
                'weighted_market_value': weighted
            }
        };

        var incrementalValue = 0;

        if (approach === 'income_weight') {
            approach = 'income';
            incrementalValue = income;
            data.evaluation.income_approach = {
                'incremental_value': income
            };
            data.evaluation_income_approaches = {
                'id': $('input[name="evaluation_' + approach + '_approaches[id]"]').val()
            };
        } else if (approach === 'sales_weight') {
            approach = 'sales';
            incrementalValue = sales;
            data.evaluation.sales_approach = {
                'incremental_value': sales
            };
            data.evaluation_sales_approaches = {
                'id': $('input[name="evaluation_' + approach + '_approaches[id]"]').val()
            };
        } else if (approach === 'cost_weight') {
            approach = 'cost';
            incrementalValue = cost;
            data.evaluation.cost_approach = {
                'incremental_value': cost
            };
            data.evaluation_cost_approaches = {
                id: $('input[name="evaluation_' + approach + '_approaches[id]"]').val()
            };
        }
        if (save == 1) {
            ViewManager.save();
        }
    };

    var average = function (name, type) {
        var inputs = $("input[name='" + name + "']");
        var amount = 0;
        var count = 0;
        inputs.each(function (index, el) {
            if (type === undefined || type === 'area') {
                amount += unmaskArea($(el).val());
            } else if (type === 'currency') {
                amount += unmask($(el).val());
            }
            count++;
        });

        return amount / count;
    };

    var averageMaskedInputs = function (name, className = false) {
        let inputs;
        if (className) {
            inputs = $("input[name='" + name + "']");
        } else {
            inputs = $("." + name);
        }
        var amount = 0;
        var count = 0;

        inputs.each(function (index, el) {
            var val = $(el).maskMoney('unmasked')[0];
            val = val ? val : 0;
            amount += val;
            count++;
        });
        if (amount === 0) {
            return amount;
        } else {
            return amount / count;
        }
    };

    var unmaskArea = function (val) {
        var value = (val || "0"),
            isNegative = value.indexOf("-") !== -1,
            decimalPart;

        // get the last position of the array that is a number(coercion makes "" to be evaluated as false)
        $(value.split(/\D/).reverse()).each(function (index, element) {
            if (element) {
                decimalPart = element;
                return false;
            }
        });
        value = value.replace(/[^\d.-]/g, '');
        return parseFloat(value);
    };

    var sumInputs = function (name, className = false) {
        var count = 0.0;
        let obj;
        if (className) {
            obj = $('.' + name);
        } else {
            obj = $('input[name="' + name + '"]');
        }
        obj.each(function (index, el) {
            let value = $(el).val();
            if (value == '') {
                value = '0';
            }
            if ($(el).hasClass('postmask-percentage')) {
                count += parseFloat(value.replace(/[^\d.-]/g, ''));
            } else if ($(el).hasClass('percent')) {
                count += parseFloat($(el).masked(value).replace(/,/g, '.'));
            } else {
                $(el).maskMoney('unmasked').each(function (index, val) {
                    if (!isNaN(val)) {
                        count += val;
                    }
                });
            }
        });

        return count;
    };

    var sumAreaInputs = function (name, className = false) {
        var count = 0.0;
        if (className) {
            $('.income-source-entry .' + name + '.disabled-input').each(function (index, el) {
                var val = unmaskArea($(el).val());
                if (!isNaN(val)) {
                    count += val;
                }
            });
        } else {
            $('.income-source-entry input[name="' + name + '"].disabled-input').each(function (index, el) {
                var val = unmaskArea($(el).val());
                if (!isNaN(val)) {
                    count += val;
                }
            });
        }
        return count;
    };

    var unmaskInput = function (el) {
        var value = 0;
        if (typeof (el) === 'object') {
            value = el.maskMoney('unmasked')[0];
        } else {
            value = $($('.' + el)[0]).maskMoney('unmasked')[0];
        }

        return value !== undefined ? value : 0;
    };

    var isNotNull = function (value) {
        return !isNaN(value) && value !== null && value.length !== 0 && value !== undefined;
    };

    var mask = function (value, removeCent) {
        value = (isNaN(value) || value == undefined) ? 0 : value;
        var newValue = parseFloat(value).toFixed(2).replace(/./g, function (c, i, a) {
            return i && c !== "." && ((a.length - i) % 3 === 0) ? ',' + c : c;
        });

        if (removeCent !== undefined) {
            var n = newValue.indexOf('.');
            newValue = newValue.substring(0, n !== -1 ? n : n.length);
            return newValue;
        }

        return newValue;
    };

    var maskAreaAndRemoveDecimalPart = function (value) {
        if ($('#selected_comp_type').val() === 'land_only' && $('#selected_analysis_type').val() === '$/Acre') {
            if (value.toString().split('.')[1] !== undefined)
                return mask(value, true) + '.' + value.toString().split('.')[1];
            else
                return mask(value, true) + '.000';
        } else {
            return mask(value).split('.')[0];
        }
    };

    var maskUnit = function (value) {
        return mask(value).split('.')[0];
    };

    var formatNumber = function (v) {
        return parseFloat(v).toFixed(2);
    };

    var unmask = function (val) {
        var value = (val || "0"),
            isNegative = value.indexOf("-") !== -1,
            decimalPart;
        // get the last position of the array that is a number(coercion makes "" to be evaluated as false)
        $(value.split(/\D/).reverse()).each(function (index, element) {
            if (element) {
                decimalPart = element;
                return false;
            }
        });
        value = value.replace(/\D/g, "");
        value = value.replace(new RegExp(decimalPart + "$"), "." + decimalPart);
        if (isNegative) {
            value = "-" + value;
        }

        return parseFloat(value);
    };

    function extractData(form) {
        var counter = {};
        var data = {};

        for (var i = 0; i < form[0].elements.length; i++) {
            var element = form[0].elements[i];

            if (counter.hasOwnProperty(element.name)) {
                counter[element.name] = counter[element.name] + 1;
                data[getName(element.name, counter[element.name])] = getValue(element);
            } else {
                counter[element.name] = 0;
                data[getName(element.name, counter[element.name])] = getValue(element);
            }
        }

        return data;
    }

    var showLoading = function () {
        $('body').LoadingOverlay("show",
            {
                image: $('body').attr('data-base-url') + "assets/img/loading.png",
                imageAnimation: '2500ms rotate_left',
                zIndex: 1005,
                background: "rgba(255, 255, 255, 0.95)"
            }
        );
    };

    var hideLoading = function () {
        $('body').LoadingOverlay("hide");
    };

    var save = function () {
        unmaskFields();
        dataToSave = false;
        var form = $('#evaluation-form');

        if (form.hasOwnProperty(0) && form[0] !== undefined) {
            var data = extractData(form);
            $.ajax({
                type: 'POST',
                url: form.attr('action'),
                async: false,
                data: data,
                success: function (response) {
                    var evaluation = JSON.parse(response);
                    if (evaluation.data) {
                        if (evaluation.data.evaluation_income_approaches_id) {
                            $('input[name="evaluation_income_approaches[id]"]').val(evaluation.data.evaluation_income_approaches_id);
                        }

                        if (evaluation.data.evaluation_sales_approaches_id) {
                            $('input[name="evaluation_sales_approaches[id]"]').val(evaluation.data.evaluation_sales_approaches_id);
                        }
                        if (evaluation.data.evaluation_cost_approaches_id) {
                            $('input[name="evaluation_cost_approaches[id]"]').val(evaluation.data.evaluation_cost_approaches_id);
                        }
                        if (evaluation.data.evaluation_multi_family_approach) {
                            $('input[name="evaluation_multi_family_approach[id]"]').val(evaluation.data.evaluation_multi_family_approach);
                        }
                    }
                }
            }).done(function () {
                hideLoading();
                focusInPostMasks();
            });
        }
    };

    var getName = function (name, counter) {
        return name.replace('index', counter);
    };

    var getValue = function (element) {
        var classList = element.classList;
        if (classList.contains('space') || classList.contains('money-acre') || classList.contains('postmask-integer') || classList.contains('postmask-currency') || classList.contains('postmask-percentage') || classList.contains('postmask-money') || classList.contains('postmask-currency') || classList.contains('postmask-percentage') || classList.contains('postmask-percentage-field')) {
            return $(element).val().replace(/[^\d.-]/g, '');
        } else {
            return $(element).val();
        }
    };

    if (window.ViewManager === undefined) {
        window.ViewManager = {};
    }

    var setLeaseCompsValues = function (obj) {
        if (obj !== undefined) {
            var current = $('.comp-current');
            current.find('span.current_weight').text(mask(obj.totalWeights)); //View
            current.find("input[name='evaluation[lease_comps][weight]']").val(obj.totalWeights);
            current.find("input[name='evaluation[lease_comps][averaged_adjusted_psf]']").val(obj.totalAverageAdjusted);

            current.find('span.current_sales_approach_value').text((obj.value) ? '$' + mask(obj.value) : 'N/A'); //View
            current.find("input[name='evaluation[lease_comps][lease_comps_value]']").val(obj.value);
            var range = [];

            for (var id in obj.comps) {
                if (obj.comps.hasOwnProperty(id)) {
                    var comp = obj.comps[id];
                    var el = $('.comp-entry[data-id=' + id + ']');
                    if ($("#comp_adjustment_mode").val() == "Dollar") {
                        el.find('span.total-adjustment').text((comp.totalAdjustment < 0 ? '-$' : '$') + mask(Math.abs(comp.totalAdjustment))); //View
                    } else {
                        el.find('span.total-adjustment').text(mask(comp.totalAdjustment)); //View
                    }
                    el.find("input[name='evaluation[lease_comps][comps][index][total_adjustment]']").val(comp.totalAdjustment);

                    el.find('span.blended_adjusted_psf').text(mask(comp.blendedAdjustedPricePSF)); //View
                    el.find("input[name='evaluation[lease_comps][comps][index][blended_adjusted_psf]']").val(comp.blendedAdjustedPricePSF);

                    el.find('span.adjusted_psf').text(mask(comp.adjustedPricePSF)); //View
                    el.find("input[name='evaluation[lease_comps][comps][index][adjusted_psf]']").val(comp.adjustedPricePSF);

                    el.find('span.averaged_adjusted_psf').text(mask(comp.averageAdjustedPSF)); //View
                    el.find("input[name='evaluation[lease_comps][comps][index][averaged_adjusted_psf]']").val(comp.averageAdjustedPSF);

                    range.push(comp.adjustedPricePSF);
                }
            }
            if (range.length)
                current.find('span.adjusted_comp_range').text("$" + mask(Math.min.apply(null, range)) + " - $" + mask(Math.max.apply(null, range))); //View
            else
                current.find('span.adjusted_comp_range').text("");
        }
    };

    var getLeaseComps = function (isAddDelete = 0) {
        var values = {
            comps: {},
            totalWeights: 0,
            totalAverageAdjusted: 0, //PSF
            value: 0
        };

        var compsEl = $('div.col.comps.comp-entry');
        var comps = values.comps;
        // var salesFields;
        // salesFields = ['time', 'operating_exp', 'location', 'construction', 'condition', 'type', 'economies_of_scale'];
        let salesFields = [];

        $('.label-value').each(function () {
            salesFields.push($(this).attr('data-name'));
        });

        if (compsEl.length > 0) {
            var i = 1;
            compsEl.each(function (index, value) {
                var id = $(value).find("input[name='evaluation[lease_comps][comps][index][comp_id]']").val();

                if (id) {
                    comps[id] = {
                        totalAdjustment: 0,
                        weight: 0,
                        salePrice: 0,
                        buildingSize: 0,
                        psf: 0,
                        adjustedPricePSF: 0,
                        blendedAdjustedPricePSF: 0
                    };

                    var totalAdjustment = 0;

                    // Getting and summing up percentages
                    for (var key in salesFields) {
                        if (salesFields.hasOwnProperty(key)) {
                            var field;
                            if ($("#comp_adjustment_mode").val() == "Dollar") {
                                field = $(value).find("input[name='evaluation[lease_comps][comps][index][" + salesFields[key] + "]']");
                            } else {
                                field = $(value).find("select[name='evaluation[lease_comps][comps][index][" + salesFields[key] + "]']");
                                if (field.val() == 'Type My Own')
                                    field = $(value).find("input[name='evaluation[lease_comps][comps][index][" + salesFields[key] + "_custom]']");
                            }

                            // var field_val=field.val().replace("$", "").replace(/\,/g, '');
                            let field_val = 0;
                            if (field.val())
                                field_val = field.val().replace(/[^\d.-]/g, '');
                            if (field && isNotNull(field_val)) {
                                comps[id][salesFields[key]] = parseFloat(field_val);
                                totalAdjustment += comps[id][salesFields[key]];
                            } else {
                                comps[id][salesFields[key]] = 0;
                            }
                        }
                    }

                    //Total adjustment
                    if (isNotNull(totalAdjustment)) {
                        comps[id].totalAdjustment = totalAdjustment;
                    }

                    //Weight
                    var weightFieldEl = $(value).find("input[name='evaluation[lease_comps][comps][index][weight]']");
                    if (weightFieldEl.length) {
                        if ($(weightFieldEl).val() && $(weightFieldEl).val().length) {
                            var weightField = $(weightFieldEl).val().replace(/,/g, '.');
                            if (weightField.length) {
                                if (weightField == "%") {
                                    weightField = 0;
                                }
                                comps[id].weight = parseFloat(weightField);
                                $(weightFieldEl).val(comps[id].weight + "%");
                            }
                        }
                    }

                    //Total weights
                    values.totalWeights += comps[id].weight;

                    var salePrice = $(value).find("input[name='single_comp[lease_rate]']").val();
                    var buildingSize = $(value).find("input[name='single_comp[space]']").val();
                    var price_psf = $(value).find("input[name='single_comp[price_psf]']").val();
                    var price_acre = $(value).find("input[name='single_comp[price_acre]']").val();

                    if (isNotNull(price_psf)) {
                        comps[id].salePrice = parseFloat(salePrice);
                        comps[id].buildingSize = parseFloat(buildingSize);
                        comps[id].psf = parseFloat(price_psf);
                        comps[id].pacre = parseFloat(price_acre);
                        if ($("#comp_adjustment_mode").val() == "Dollar") {
                            if ($('#selected_comp_type').val() === 'land_only' && $('#selected_analysis_type').val() === '$/Acre') {
                                comps[id].adjustedPricePSF = parseFloat(comps[id].pacre + comps[id].totalAdjustment);
                            } else {
                                comps[id].adjustedPricePSF = parseFloat(comps[id].psf + comps[id].totalAdjustment);
                            }
                        } else {
                            if ($('#selected_comp_type').val() === 'land_only' && $('#selected_analysis_type').val() === '$/Acre') {
                                comps[id].adjustedPricePSF = parseFloat(comps[id].pacre + (comps[id].pacre * comps[id].totalAdjustment / 100));
                            } else {
                                comps[id].adjustedPricePSF = parseFloat(comps[id].psf + (comps[id].psf * comps[id].totalAdjustment / 100));
                            }
                        }
                    }

                    if (isNotNull(comps[id].adjustedPricePSF) && isNotNull(comps[id].weight)) {
                        var weight;
                        if (isAddDelete == 1) {
                            if (compsEl.length == 3 && i == 3) {
                                weight = 33.34;
                            } else if (compsEl.length == 3 && i != 3) {
                                weight = 33.33;
                            } else {
                                var compCount = compsEl.length;
                                weight = 100 / compCount;
                            }
                        } else {
                            weight = comps[id].weight;
                        }
                        comps[id].averageAdjustedPSF = parseFloat(comps[id].adjustedPricePSF * (weight / 100));
                        comps[id].averageAdjustedPSF = parseFloat(comps[id].averageAdjustedPSF);

                        if (price_psf) {
                            comps[id].blendedAdjustedPricePSF = parseFloat((weight / 100) * price_psf);
                            comps[id].blendedAdjustedPricePSF = parseFloat(comps[id].blendedAdjustedPricePSF);
                        }

                        values.totalAverageAdjusted += comps[id].averageAdjustedPSF;
                    }
                    values.comps[id] = comps[id];
                }
                i++;
            });
            var compCount = compsEl.length;
            var w = 100 / compCount;
            var updated = false;

            var allWeight = [];

            var needToSplit = true;

            Object.keys(comps).forEach(function (item) {
                if (comps[item].weight != w) {
                    updated = true;
                }
                allWeight.push(comps[item].weight);

                if (comps[item].index + 1 == compCount) {
                    if (comps[item].weight == 0) {
                        needToSplit = true;
                    }
                }
            });
            if (needToSplit) {
                const index = allWeight.indexOf(0);
                if (index > -1) {
                    allWeight.splice(index, 1);
                }
            }
            if (allWeight.length == 0 && values.totalWeights == 0) {
                updated = false;
                values.totalWeights = 100;
            }
            if (allWeight.every((val, i, arr) => val === arr[0]) && values.totalWeights == 100) {
                updated = false;
                values.totalWeights = 100;
            }
            if (isAddDelete == 1) {
                updated = false;
                values.totalWeights = 100;
            }
            if (allWeight.length == 3) {
                let count = 0;
                allWeight.forEach(e => {
                    if (e == 33.33 || e == 33.34)
                        count++;
                });
                if (count == 3) {
                    updated = false;
                    values.totalWeights = 100;
                }
            }
            if (updated == false) {
                var weightFieldEl = $('div.col.comps.comp-entry').find("input[name='evaluation[lease_comps][comps][index][weight]']");
                $(weightFieldEl).val(w + "%");
                if (w.toFixed(2) == 33.33) {
                    $(weightFieldEl).val(w.toFixed(2) + "%");
                    $("input[name='evaluation[lease_comps][comps][index][weight]']:nth(2)").val("33.34%");
                }
            }
            values.totalAverageAdjusted = parseFloat(values.totalAverageAdjusted);
        }

        // Check whether the weight is 100%.  If it isn't, disable the next button
        var button = $('button.evaluations-next');
        var currentWeight = $('.current_weight').parent('.field');

        if ((values.totalWeights !== 100)) {
            // button.attr('disabled', 'disabled');
            $('.tooltip-wrapper').tooltip({
                delay: 50,
                position: 'bottom',
                tooltip: 'Please ensure that weighting equals 100%'
            });
            currentWeight.addClass('error');
        } else {
            button.attr('disabled', false);
            currentWeight.removeClass('error');
        }
        return values;
    };

    var setCapCompsValues = function (obj) {
        if (obj !== undefined) {
            var weightedAvg = 0;
            var current = $('.comp-current');
            current.find("input[name='evaluation[cap_comps][weight]']").val(obj.totalWeights);
            current.find('span.current_weight').text(mask(obj.totalWeights));
            current.find('span.high_cap_rate').text(mask(obj.highCapRate));
            current.find('input[name="evaluation[cap_comps][high_cap_rate]"]').val(obj.highCapRate);
            current.find('span.low_cap_rate').text(mask(obj.lowCapRate));
            current.find('input[name="evaluation[cap_comps][low_cap_rate]"]').val(obj.lowCapRate);
            var compsEl = $('div.col.comps.comp-entry');
            var total_comps = parseFloat(compsEl.length);
            if (compsEl.length > 0) {
                compsEl.each(function (index, value) {
                    var cap_rate = $(value).find("input[name='evaluation[cap_comps][comps][index][cap_rate]']").val();
                    var weight = $(value).find("input[name='evaluation[cap_comps][comps][index][weight]']").val();
                    weightedAvg = parseFloat(weightedAvg) + (parseFloat(cap_rate) * parseFloat(weight));
                });
            }
            current.find('span.weigted_average').text(mask(weightedAvg / 100));
            current.find('input[name="evaluation[cap_comps][weigted_average]"]').val(weightedAvg / 100);
            current.find('span.rounded_average').text(mask(obj.totalCapRate / total_comps));
            current.find('input[name="evaluation[cap_comps][rounded_average]"]').val(obj.totalCapRate / total_comps);
        }
    };

    var getCapComps = function (isAddDelete = 0) {
        var values = {
            comps: {},
            totalWeights: 0,
            highCapRate: 0,
            lowCapRate: 0,
            totalCapRate: 0,
            weightedAvg: 0
        };

        var compsEl = $('div.col.comps.comp-entry');
        var comps = values.comps;

        if (compsEl.length > 0) {
            var i = 1;
            compsEl.each(function (index, value) {
                var id = $(value).find("input[name='evaluation[cap_comps][comps][index][comp_id]']").val();

                if (id) {
                    comps[id] = {
                        weight: 0
                    };
                    //Weight
                    var weightFieldEl = $(value).find("input[name='evaluation[cap_comps][comps][index][weight]']");
                    if (weightFieldEl.length) {
                        if ($(weightFieldEl).val() && $(weightFieldEl).val().length) {
                            var weightField = $(weightFieldEl).val().replace(/,/g, '.');
                            if (weightField.length) {
                                if (weightField == "%") {
                                    weightField = 0;
                                }
                                comps[id].weight = parseFloat(weightField);
                                $(weightFieldEl).val(comps[id].weight + "%");
                            }
                        }
                    }
                    //Total weights
                    values.totalWeights += comps[id].weight;
                    values.comps[id] = comps[id];
                    var cap_rate = $(value).find("input[name='evaluation[cap_comps][comps][index][cap_rate]']").val();
                    if (i == 1)
                        values.lowCapRate = cap_rate;
                    else if (parseFloat(cap_rate) < parseFloat(values.lowCapRate))
                        values.lowCapRate = parseFloat(cap_rate);
                    if (parseFloat(cap_rate) > parseFloat(values.highCapRate))
                        values.highCapRate = parseFloat(cap_rate);
                    values.totalCapRate = parseFloat(values.totalCapRate) + parseFloat(cap_rate);
                }
                i++;
            });
            var compCount = compsEl.length;
            var w = 100 / compCount;
            var updated = false;

            var allWeight = [];

            var needToSplit = true;

            Object.keys(comps).forEach(function (item) {
                if (comps[item].weight != w) {
                    updated = true;
                }
                allWeight.push(comps[item].weight);

                if (comps[item].index + 1 == compCount) {
                    if (comps[item].weight == 0) {
                        needToSplit = true;
                    }
                }
            });
            if (needToSplit) {
                const index = allWeight.indexOf(0);
                if (index > -1) {
                    allWeight.splice(index, 1);
                }
            }
            if (allWeight.length == 0 && values.totalWeights == 0) {
                updated = false;
                values.totalWeights = 100;
            }
            if (allWeight.every((val, i, arr) => val === arr[0]) && values.totalWeights == 100) {
                updated = false;
                values.totalWeights = 100;
            }
            if (isAddDelete == 1) {
                updated = false;
                values.totalWeights = 100;
            }
            if (allWeight.length == 3) {
                let count = 0;
                allWeight.forEach(e => {
                    if (e == 33.33 || e == 33.34)
                        count++;
                });
                if (count == 3) {
                    updated = false;
                    values.totalWeights = 100;
                }
            }
            if (updated == false) {
                var weightFieldEl = $('div.col.comps.comp-entry').find("input[name='evaluation[cap_comps][comps][index][weight]']");
                $(weightFieldEl).val(w + "%");
                if (w.toFixed(2) == 33.33) {
                    $(weightFieldEl).val(w.toFixed(2) + "%");
                    $("input[name='evaluation[cap_comps][comps][index][weight]']:nth(2)").val("33.34%");
                }
            }
        }

        // Check whether the weight is 100%.  If it isn't, disable the next button
        var button = $('button.evaluations-next');
        var currentWeight = $('.current_weight').parent('.field');

        if ((values.totalWeights !== 100)) {
            // button.attr('disabled', 'disabled');
            $('.tooltip-wrapper').tooltip({
                delay: 50,
                position: 'bottom',
                tooltip: 'Please ensure that weighting equals 100%'
            });
            currentWeight.addClass('error');
        } else {
            button.attr('disabled', false);
            currentWeight.removeClass('error');
        }
        return values;
    };

    var getResSalesValues = function (isAddDelete = 0, autoCalculate = 0) {
        var values = {
            comps: {},
            totalWeights: 0,
            totalAverageAdjusted: 0, //PSF
            value: 0,
            incrementalValue: 0
        };

        var compsEl = $('div.col.comps.comp-entry');
        var comps = values.comps;
        var salesFields = ['time', 'location', 'gross_living_area_sf', 'basement', 'land_size', 'year_built', 'bedrooms', 'bathrooms', 'garage', 'heating_cooling', 'fencing', 'fireplace', 'other_amenities', 'condition'];
        if (compsEl.length > 0) {
            var i = 1;
            compsEl.each(function (index, value) {
                var id = $(value).find("input[name='evaluation[sales_approach][comps][index][comp_id]']").val();

                if (id) {
                    comps[id] = {
                        totalAdjustment: 0,
                        weight: 0,
                        salePrice: 0,
                        buildingSize: 0,
                        psf: 0,
                        adjustedPricePSF: 0,
                        blendedAdjustedPricePSF: 0
                    };

                    var totalAdjustment = 0;
                    var salePrice = $(value).find("input[name='single_comp[sale_price]']").val();

                    // Getting and summing up percentages
                    for (var key in salesFields) {
                        if (salesFields.hasOwnProperty(key)) {
                            let field;

                            field = $(value).find("input[name='evaluation[sales_approach][comps][index][" + salesFields[key] + "]']");

                            let percentage = ['time', 'location', 'condition'];
                            let dollar = ['gross_living_area_sf', 'basement', 'land_size', 'year_built', 'bedrooms', 'bathrooms', 'fireplace'];

                            let calculate_adjustment = 0;
                            if (autoCalculate && (index == compsEl.length - 1) && (percentage.includes(salesFields[key]) || dollar.includes(salesFields[key]))) {
                                let subject_val = $('[name="evaluation[sales_approach][current][' + salesFields[key] + ']"]').val().replace(/[^\d.-]/g, '');

                                if (percentage.includes(salesFields[key])) {
                                    calculate_adjustment = parseFloat(parseFloat(salePrice) * parseFloat(subject_val) / 100).toFixed(2);
                                } else if (dollar.includes(salesFields[key])) {
                                    let diffrence = 0;
                                    let subject_value = 0;
                                    let comp_value = 0;
                                    let span = salesFields[key];
                                    if (span == 'gross_living_area_sf') {
                                        span = 'gross_living_sq_ft';
                                    }
                                    if (salesFields[key] == 'basement') {
                                        subject_value = $('[name="evaluation[sales_approach][current][' + salesFields[key] + ']"').val().replace(/[^\d.-]/g, '');

                                        let basement_finished = $('#basement_finished').val().replace(/[^\d.-]/g, '');
                                        let basement_unfinished = $('#basement_unfinished').val().replace(/[^\d.-]/g, '');
                                        let basement_finished_sq_ft = $(value).find('span.basement_finished_sq_ft').html().replace(/[^\d.-]/g, '');
                                        let basement_unfinished_sq_ft = $(value).find('span.basement_unfinished_sq_ft').html().replace(/[^\d.-]/g, '');

                                        comp_value = (parseFloat(basement_finished) * parseFloat(basement_finished_sq_ft)) + (parseFloat(basement_unfinished) * parseFloat(basement_unfinished_sq_ft));
                                        calculate_adjustment = parseFloat(parseFloat(subject_value) - parseFloat(comp_value)).toFixed(2);
                                    } else {
                                        subject_value = $('[name="current[' + salesFields[key] + ']"').val().replace(/[^\d.-]/g, '');
                                        comp_value = $(value).find('span.' + span).html().replace(/[^\d.-]/g, '');

                                        if (comp_value == "")
                                            comp_value = 0;
                                        diffrence = parseFloat(subject_value) - parseFloat(comp_value);
                                        calculate_adjustment = parseFloat(subject_val * diffrence).toFixed(2);
                                    }
                                }
                                field.val(calculate_adjustment);
                            }
                            let field_val = field.val().replace(/[^\d.-]/g, '');
                            if (field && isNotNull(field_val)) {
                                comps[id][salesFields[key]] = parseFloat(field_val);
                                totalAdjustment += comps[id][salesFields[key]];
                            } else {
                                comps[id][salesFields[key]] = 0;
                            }
                        }
                    }

                    //Total adjustment
                    if (isNotNull(totalAdjustment)) {
                        comps[id].totalAdjustment = totalAdjustment;
                    }

                    //Weight
                    var weightFieldEl = $(value).find("input[name='evaluation[sales_approach][comps][index][weight]']");
                    if (weightFieldEl.length) {
                        if ($(weightFieldEl).val() && $(weightFieldEl).val().length) {
                            var weightField = $(weightFieldEl).val().replace(/,/g, '.');
                            if (weightField.length) {
                                if (weightField == "%") {
                                    weightField = 0;
                                }
                                comps[id].weight = parseFloat(weightField);
                                $(weightFieldEl).val(comps[id].weight + "%");
                            }
                        }
                    }

                    //Total weights
                    values.totalWeights += comps[id].weight;

                    var buildingSize = $(value).find("input[name='single_comp[building_size]']").val();

                    if (isNotNull(salePrice)) {
                        comps[id].salePrice = parseFloat(salePrice);
                        comps[id].buildingSize = parseFloat(buildingSize);
                        comps[id].adjustedPricePSF = parseFloat(comps[id].salePrice + comps[id].totalAdjustment);
                    }

                    if (isNotNull(comps[id].adjustedPricePSF) && isNotNull(comps[id].weight)) {
                        var weight;
                        if (isAddDelete == 1) {
                            if (compsEl.length == 3 && i == 3) {
                                weight = 33.34;
                            } else if (compsEl.length == 3 && i != 3) {
                                weight = 33.33;
                            } else {
                                var compCount = compsEl.length;
                                weight = 100 / compCount;
                            }
                        } else {
                            weight = comps[id].weight;
                        }
                        comps[id].averageAdjustedPSF = parseFloat(comps[id].adjustedPricePSF * (weight / 100));
                        comps[id].averageAdjustedPSF = parseFloat(comps[id].averageAdjustedPSF);

                        if (salePrice) {
                            comps[id].blendedAdjustedPricePSF = parseFloat((weight / 100) * salePrice);
                            comps[id].blendedAdjustedPricePSF = parseFloat(comps[id].blendedAdjustedPricePSF);
                        }
                        values.totalAverageAdjusted += comps[id].averageAdjustedPSF;
                    }
                    values.comps[id] = comps[id];
                }
                i++;
            });

            var compCount = compsEl.length;
            var w = 100 / compCount;
            var updated = false;

            var allWeight = [];
            var needToSplit = true;

            Object.keys(comps).forEach(function (item) {
                if (comps[item].weight != w) {
                    updated = true;
                }
                allWeight.push(comps[item].weight);

                if (comps[item].index + 1 == compCount) {
                    if (comps[item].weight == 0) {
                        needToSplit = true;
                    }
                }
            });

            if (needToSplit) {
                const index = allWeight.indexOf(0);
                if (index > -1) {
                    allWeight.splice(index, 1);
                }
            }

            if (allWeight.length == 0 && values.totalWeights == 0) {
                updated = false;
                values.totalWeights = 100;
            }

            if (allWeight.every((val, i, arr) => val === arr[0]) && values.totalWeights == 100) {
                updated = false;
                values.totalWeights = 100;
            }

            if (isAddDelete == 1) {
                updated = false;
                values.totalWeights = 100;
            }

            if (allWeight.length == 3) {

                let count = 0;
                allWeight.forEach(e => {
                    if (e == 33.33 || e == 33.34)
                        count++;
                });

                if (count == 3) {
                    updated = false;
                    values.totalWeights = 100;
                }
            }

            if (updated == false) {
                var weightFieldEl = $('div.col.comps.comp-entry').find("input[name='evaluation[sales_approach][comps][index][weight]']");

                $(weightFieldEl).val(w + "%");
                if (w.toFixed(2) == 33.33) {
                    $(weightFieldEl).val(w.toFixed(2) + "%");
                    $("input[name='evaluation[sales_approach][comps][index][weight]']:nth(2)").val("33.34%");
                }
            }
            values.totalAverageAdjusted = parseFloat(values.totalAverageAdjusted);
        }

        // Check whether the weight is 100%.  If it isn't, disable the next button
        var button = $('button.evaluations-next');
        var currentWeight = $('.current_weight').parent('.field');

        if ((values.totalWeights !== 100)) {
            button.attr('disabled', 'disabled');
            $('.tooltip-wrapper').tooltip({
                delay: 50,
                position: 'bottom',
                tooltip: 'Please ensure that weighting equals 100%'
            });
            currentWeight.addClass('error');
        } else {
            button.attr('disabled', false);
            currentWeight.removeClass('error');
        }
        return values;
    };

    var setResSalesValues = function (obj) {
        if (obj !== undefined) {

            var current = $('.comp-current');
            current.find('span.current_weight').text(mask(obj.totalWeights)); //View
            current.find("input[name='evaluation[sales_approach][weight]']").val(obj.totalWeights);
            // current.find('span.current_averaged_adjusted_psf').text(mask(obj.totalAverageAdjusted)+" /SF"); //View
            current.find("input[name='evaluation[sales_approach][averaged_adjusted_psf]']").val(obj.totalAverageAdjusted);
            let finalValue = 0;
            $('.data').each(function () {
                sqftValue = $(this).find('.sqft_value').val();
                weightValue = $(this).find('.weightsf_value').val();
                finalValue += getResTotalSalesValue(obj.totalAverageAdjusted, sqftValue, weightValue);
            });
            current.find('span.current_sales_approach_value').text((finalValue) ? '$' + mask(finalValue) : 'N/A'); //View
            current.find("input[name='evaluation[sales_approach][sales_approach_value]']").val(finalValue);
            current.find("input[name='evaluation[sales_approach][total_comp_adj]']").val(obj.compAdj);

            current.find("input[name='evaluation[sales_approach][incremental_value]']").val(obj.incrementalValue);

            for (var id in obj.comps) {
                if (obj.comps.hasOwnProperty(id)) {
                    var comp = obj.comps[id];
                    var el = $('.comp-entry[data-id=' + id + ']');

                    el.find('span.total-adjustment').text((comp.totalAdjustment < 0 ? '-$' : '$') + mask(Math.abs(comp.totalAdjustment))); //View

                    el.find("input[name='evaluation[sales_approach][comps][index][total_adjustment]']").val(comp.totalAdjustment);

                    el.find('span.blended_adjusted_psf').text(mask(comp.blendedAdjustedPricePSF)); //View
                    el.find("input[name='evaluation[sales_approach][comps][index][blended_adjusted_psf]']").val(comp.blendedAdjustedPricePSF);

                    el.find('span.adjusted_psf').text(mask(comp.adjustedPricePSF)); //View
                    el.find("input[name='evaluation[sales_approach][comps][index][adjusted_psf]']").val(comp.adjustedPricePSF);

                    el.find('span.averaged_adjusted_psf').text(mask(comp.averageAdjustedPSF)); //View
                    el.find("input[name='evaluation[sales_approach][comps][index][averaged_adjusted_psf]']").val(comp.averageAdjustedPSF);
                }
            }
        }
    };

    var getResTotalSalesValue = function (adjust, sf, weight) {
        let value = (sf * weight) / 100;
        let total = adjust * value;
        return total;
    }

    var setResSidebar = function (obj, save = 0) {
        var d1 = setIncomeSidebar(obj);
        var d2 = setSalesSidebar(obj);
        var d3 = setCostSidebar(obj);

        $.when(d1, d2, d3).then(function (res1, res2, res3) {
            var values = {
                indicatedValueAnnual: 0,
                salesApproachValue: 0,
                totalCostValuation: 0
            };

            var data1 = !isNaN(res1) ? { income_approach_value: res1 } : JSON.parse(res1[0]);
            if (isNotNull(data1.income_approach_value)) {
                values.indicatedValueAnnual = parseFloat(data1.income_approach_value);
            }
            var data = !isNaN(res2) ? { sales_approach_value: res2 } : JSON.parse(res2[0]);
            if (isNotNull(data.sales_approach_value)) {
                values.salesApproachValue = parseFloat(data.sales_approach_value);
            }

            var data3 = !isNaN(res3) ? { final: { total_cost_valuation: res3 } } : JSON.parse(res3[0]);
            if (data3.final && isNotNull(data3.final.total_cost_valuation)) {
                values.totalCostValuation = parseFloat(data3.final.total_cost_valuation);
            }
            setResWeight(values, save);
        });
    };

    var setResWeight = function (obj, save = 0) {
        //Income Approach
        var incomeWeight = $('#income-approach-percentage').attr('data-value');
        if (!isNotNull(incomeWeight)) {
            incomeWeight = 0;
        }
        var incomeIncrementalValue = (incomeWeight / 100) * obj.indicatedValueAnnual;

        //Sales Approach
        var salesWeight = $('#sales-approach-percentage').attr('data-value');
        if (!isNotNull(salesWeight)) {
            salesWeight = 0;
        }
        var salesIncrementalValue = (salesWeight / 100) * obj.salesApproachValue;

        //Cost Approach
        var costWeight = $('#cost-approach-percentage').attr('data-value');
        if (!isNotNull(costWeight)) {
            costWeight = 0;
        }
        var costIncrementalValue = (costWeight / 100) * obj.totalCostValuation;

        var weightedValue = incomeIncrementalValue + salesIncrementalValue + costIncrementalValue;

        if (isNotNull(weightedValue)) {
            var buildingSize = $("input[name='evaluation[building_size]']").val();
            var total_weight_psf = 0;
            if (buildingSize > 0) {
                total_weight_psf = parseFloat(weightedValue) / parseFloat(buildingSize);
            }
            $('span#weighted-value').text(mask(weightedValue, true));
            $('#weighted-value-input').val(weightedValue);
            total_weight_psf <= 10 ? $('#total-weight-psf').text(mask(total_weight_psf)) : $('#total-weight-psf').text(mask(total_weight_psf, true));
        } else {
            $('span#weighted-value').text(mask(0, true));
            $('#weighted-value-input').val(0);
            $('#total-weight-psf').text(mask(0, true));
            weightedValue = 0;
        }
        updateResEvaluation(incomeIncrementalValue, salesIncrementalValue, costIncrementalValue, weightedValue, save);
    };

    var updateResEvaluation = function (income, sales, cost, weighted, save = 0) {
        var form = $("#weight-form");
        var approach = form.find('[name=approach]').val();

        var data = {
            'evaluation': {
                'id': form.find('input[name=id]').val(),
                'weighted_market_value': weighted
            }
        };

        var incrementalValue = 0;

        if (approach === 'income_weight') {
            approach = 'income';
            incrementalValue = income;
            data.evaluation.income_approach = {
                'incremental_value': income
            };
            data.evaluation_income_approaches = {
                'id': $('input[name="evaluation_' + approach + '_approaches[id]"]').val()
            };
        } else if (approach === 'sales_weight') {
            approach = 'sales';
            incrementalValue = sales;
            data.evaluation.sales_approach = {
                'incremental_value': sales
            };
            data.evaluation_sales_approaches = {
                'id': $('input[name="evaluation_' + approach + '_approaches[id]"]').val()
            };
        } else if (approach === 'cost_weight') {
            approach = 'cost';
            incrementalValue = cost;
            data.evaluation.cost_approach = {
                'incremental_value': cost
            };
            data.evaluation_cost_approaches = {
                id: $('input[name="evaluation_' + approach + '_approaches[id]"]').val()
            };
        }
        if (save == 1) {
            ViewManager.save();
        }
    };

    ViewManager.getIncomeValues = getIncomeValues;
    ViewManager.setIncomeValues = setIncomeValues;
    ViewManager.getSalesValues = getSalesValues;
    ViewManager.getMultiValues = getMultiValues;
    ViewManager.setMultiValues = setMultiValues;
    ViewManager.setSalesValues = setSalesValues;
    ViewManager.getCostValues = getCostValues;
    ViewManager.setCostValues = setCostValues;
    ViewManager.setIncomeSidebar = setIncomeSidebar;
    ViewManager.setSalesSidebar = setSalesSidebar;
    ViewManager.setCostSidebar = setCostSidebar;
    ViewManager.setSidebar = setSidebar;
    ViewManager.setWeight = setWeight;
    ViewManager.calcIncomeValue = calcIncomeValue;
    ViewManager.initIncomeSourceEvents = initIncomeSourceEvents;
    ViewManager.extractData = extractData;
    ViewManager.save = save;
    ViewManager.getLeaseComps = getLeaseComps;
    ViewManager.setLeaseCompsValues = setLeaseCompsValues;
    ViewManager.getCapComps = getCapComps;
    ViewManager.setCapCompsValues = setCapCompsValues;
    ViewManager.getResSalesValues = getResSalesValues;
    ViewManager.setResSalesValues = setResSalesValues;
    ViewManager.setResSidebar = setResSidebar;
    ViewManager.setResWeight = setResWeight;
    ViewManager.getResCostValues = getResCostValues;
    ViewManager.setResCostValues = setResCostValues;

    $(document).on('change', '.no-calc', function () {
        $('.income-source-entry').each(function () {
            // var sq_ft = $(this).find($("input[name='evaluation[income_approach][income_source][index][square_feet]"));
            // var rent_sq_ft = $(this).find($("input[name='evaluation[income_approach][income_source][index][rent_sq_ft]"));
            let sq_ft = $(this).find($(".prop_space"));
            let rent_sq_ft = $(this).find($(".field-rent-sq-ft"));

            sq_ft.change(function () {
                var sq_ft_value = $(this).val().trim();

                if (sq_ft_value != 0) {
                    rent_sq_ft.prop("disabled", false);
                    // rent_sq_ft.removeClass('disabled-input')
                } else {
                    rent_sq_ft.prop("disabled", true);
                    rent_sq_ft.addClass('disabled-input');
                }
            });
        });
    });

    $(document).on('click', '#save_income_eval_form', function () {
        save();
    });

    window.onbeforeunload = function (e) {
        window.onbeforeunload = null;
        e.stopPropagation();
        if (((location.pathname.indexOf('/income') !== -1) || (location.pathname.indexOf('/overview') !== -1) || (location.pathname.indexOf('/sales') !== -1) || (location.pathname.indexOf('/cost') !== -1)) && dataToSave == true) {
            $('#modal-save-changes').modal('open');
            return false;
        }
    };

    $(document).on('click', 'a', function (e) {
        window.onbeforeunload = null;
        e.stopPropagation();
        if (((location.pathname.indexOf('/income') !== -1) || (location.pathname.indexOf('/sales') !== -1) || (location.pathname.indexOf('/overview') !== -1) || (location.pathname.indexOf('/cost') !== -1) || (location.pathname.indexOf('/leaseComps') !== -1) || (location.pathname.indexOf('/capComps') !== -1)) && dataToSave == true &&
            !$(this).hasClass("add-new-operating-expense") && !$(this).hasClass("add-new-income-source") && !$(this).hasClass("evaluations-next") && !$(this).hasClass("evaluations-previous") && ($(this).attr('id') !== 'create-new-comp') && !$(this).hasClass("add-additional-feature") && !$(this).hasClass("delete-additional-feature") &&
            !$(this).hasClass("add-additional-traffic-count") && !$(this).hasClass("add-additional-property-type") && !$(this).parent().hasClass('overview-side-menu') && !$(this).hasClass("add-new-cost-approach-improvement") && !$(this).hasClass("modal-close") && $(this).attr('href') != "#" && !$(this).hasClass("open_add_adjustment_modal") &&
            !$(this).hasClass("convert_to_dropdown") && !$(this).hasClass("open_add_basement_adjustment_modal") && !$(this).hasClass("open_add_amenities_adjustment_modal") && !$(this).hasClass("calculate_amenity") && !$(this).hasClass("add_new_row") && !$(this).hasClass("delete") && !$(this).hasClass('delete-label') && !$(this).hasClass('add-label') && !$(this).hasClass('add-additional-unit-type')) {
            var link = $(this).attr('href');
            $(".btn_link").attr('data-object', link);
            $('#modal-save-changes').modal('open');
            return false;
        }
    });

    $(document).on('click', 'button', function () {
        if (((location.pathname.indexOf('/income') !== -1) || (location.pathname.indexOf('/overview') !== -1) || (location.pathname.indexOf('/sales') !== -1) || (location.pathname.indexOf('/cost') !== -1)) && ($(this).hasClass("evaluations-previous") || $(this).hasClass("evaluations-next"))) {
            dataToSave = false;
        }
    });

    $(document).on('focus', '.wysiwyg .textarea,textarea,input[type=text]:not(.select-dropdown,#route),input[type=radio]:not(.select-dropdown)', function () {
        previousval = $(this).val();
    });

    $(document).on('keyup', '.income-approach-field', function (e) {
        if (location.pathname.indexOf('/income') !== -1) {
            currentval = $(this).val();
            if (previousval !== currentval) {
                dataToSave = true;
            }
        }
    });

    $(document).on('keyup', '.tax_assessment', function (e) {
        var land_assessment = $('[name="evaluation[land_assessment]"]').val().replace(/[^\d.-]/g, '');
        var improve_assessment = $('[name="evaluation[structure_assessment]"]').val().replace(/[^\d.-]/g, '');
        var total_land_improvement = parseFloat(land_assessment) + parseFloat(improve_assessment);
        $('#total_land_improvement').val(total_land_improvement.toFixed(2));
        $('#total_land_improvement').keyup();
        if (location.pathname.indexOf('evaluations/overview') !== -1)
            calculate_price_square_foot();
    });

    $(document).on('blur', '#landsize', function (e) {
        if (location.pathname.indexOf('evaluations/overview') !== -1)
            calculate_price_square_foot();
    });
    $(document).on('change', '[name="evaluation[building_size]"]', function () {
        if (location.pathname.indexOf('evaluations/overview') !== -1)
            calculate_price_square_foot();
    });
    var calculate_price_square_foot = function () {
        var total_land_improvement = $('#total_land_improvement').val().replace(/[^\d.-]/g, '');
        var building_size = $('[name="evaluation[building_size]"]').val().replace(/[^\d.-]/g, '');
        if ($('.select_comp_type:checked').val() == "land_only") {
            building_size = $('#landsize').val().replace(/[^\d.-]/g, '');
            if ($("#landdimension").val() == "ACRE") {
                building_size = $('#landsize').val() * 43560;
            }
        }
        var price_square_foot = (parseFloat(total_land_improvement) / parseFloat(building_size)).toFixed(2);
        $('[name="evaluation[price_square_foot]"]').val(price_square_foot);
        $('[name="evaluation[price_square_foot]"]').keyup();
    };
    $(document).on('change', '#landdimension', function (e) {
        if (location.pathname.indexOf('evaluations/overview') !== -1)
            calculate_price_square_foot();
    });
    $(document).on('change', '#analysis_type', function (e) {
        if ($(this).val() == "$/SF") {
            $("#landdimension").val("SF");
            $("#land_dimension_input").val("SF");
        }
        else {
            $("#landdimension").val("ACRE");
            $("#land_dimension_input").val("ACRE");
        }
        $("#landdimension").material_select();
        $("#landdimension").change();
    });
    $(document).on('change', '.select_comp_type', function (e) {
        if (location.pathname.indexOf('evaluations/overview') !== -1)
            calculate_price_square_foot();
    });

    $(document).on('keydown', function (e) {
        if (location.pathname.indexOf('/evaluations') !== -1 && (e.keyCode === 116 || (e.ctrlKey && e.shiftKey && e.which === 82))) {
            dataToSave = false;
        }
    });
})();